/**
 * vis-data
 * http://visjs.org/
 *
 * Manage unstructured data using DataSet. Add, update, and remove data, and listen for changes in the data.
 *
 * @version 7.1.4
 * @date    2022-03-15T15:23:59.245Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).vis = t.vis || {});
}(this, function (t) {
  function e(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  var r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    n = {
      exports: {}
    },
    i = function i(t) {
      return t && t.Math == Math && t;
    },
    o = i("object" == typeof globalThis && globalThis) || i("object" == typeof window && window) || i("object" == typeof self && self) || i("object" == typeof r && r) || function () {
      return this;
    }() || Function("return this")(),
    a = function a(t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    },
    u = !a(function () {
      var t = function () {}.bind();
      return "function" != typeof t || t.hasOwnProperty("prototype");
    }),
    s = u,
    c = Function.prototype,
    f = c.apply,
    l = c.call,
    h = "object" == typeof Reflect && Reflect.apply || (s ? l.bind(f) : function () {
      return l.apply(f, arguments);
    }),
    p = u,
    v = Function.prototype,
    d = v.bind,
    y = v.call,
    g = p && d.bind(y, y),
    m = p ? function (t) {
      return t && g(t);
    } : function (t) {
      return t && function () {
        return y.apply(t, arguments);
      };
    },
    b = function b(t) {
      return "function" == typeof t;
    },
    _ = {},
    w = !a(function () {
      return 7 != Object.defineProperty({}, 1, {
        get: function get() {
          return 7;
        }
      })[1];
    }),
    O = u,
    E = Function.prototype.call,
    T = O ? E.bind(E) : function () {
      return E.apply(E, arguments);
    },
    x = {},
    k = {}.propertyIsEnumerable,
    S = Object.getOwnPropertyDescriptor,
    A = S && !k.call({
      1: 2
    }, 1);
  x.f = A ? function (t) {
    var e = S(this, t);
    return !!e && e.enumerable;
  } : k;
  var j,
    P,
    I = function I(t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    },
    D = m,
    L = D({}.toString),
    C = D("".slice),
    R = function R(t) {
      return C(L(t), 8, -1);
    },
    M = m,
    F = a,
    N = R,
    z = o.Object,
    q = M("".split),
    Y = F(function () {
      return !z("z").propertyIsEnumerable(0);
    }) ? function (t) {
      return "String" == N(t) ? q(t, "") : z(t);
    } : z,
    G = o.TypeError,
    X = function X(t) {
      if (null == t) throw G("Can't call method on " + t);
      return t;
    },
    U = Y,
    W = X,
    V = function V(t) {
      return U(W(t));
    },
    H = b,
    $ = function $(t) {
      return "object" == typeof t ? null !== t : H(t);
    },
    B = {},
    J = B,
    K = o,
    Q = b,
    Z = function Z(t) {
      return Q(t) ? t : void 0;
    },
    tt = function tt(t, e) {
      return arguments.length < 2 ? Z(J[t]) || Z(K[t]) : J[t] && J[t][e] || K[t] && K[t][e];
    },
    et = m({}.isPrototypeOf),
    rt = tt("navigator", "userAgent") || "",
    nt = o,
    it = rt,
    ot = nt.process,
    at = nt.Deno,
    ut = ot && ot.versions || at && at.version,
    st = ut && ut.v8;
  st && (P = (j = st.split("."))[0] > 0 && j[0] < 4 ? 1 : +(j[0] + j[1])), !P && it && (!(j = it.match(/Edge\/(\d+)/)) || j[1] >= 74) && (j = it.match(/Chrome\/(\d+)/)) && (P = +j[1]);
  var ct = P,
    ft = ct,
    lt = a,
    ht = !!Object.getOwnPropertySymbols && !lt(function () {
      var t = Symbol();
      return !String(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && ft && ft < 41;
    }),
    pt = ht && !Symbol.sham && "symbol" == typeof Symbol.iterator,
    vt = tt,
    dt = b,
    yt = et,
    gt = pt,
    mt = o.Object,
    bt = gt ? function (t) {
      return "symbol" == typeof t;
    } : function (t) {
      var e = vt("Symbol");
      return dt(e) && yt(e.prototype, mt(t));
    },
    _t = o.String,
    wt = function wt(t) {
      try {
        return _t(t);
      } catch (t) {
        return "Object";
      }
    },
    Ot = b,
    Et = wt,
    Tt = o.TypeError,
    xt = function xt(t) {
      if (Ot(t)) return t;
      throw Tt(Et(t) + " is not a function");
    },
    kt = xt,
    St = function St(t, e) {
      var r = t[e];
      return null == r ? void 0 : kt(r);
    },
    At = T,
    jt = b,
    Pt = $,
    It = o.TypeError,
    Dt = {
      exports: {}
    },
    Lt = o,
    Ct = Object.defineProperty,
    Rt = function Rt(t, e) {
      try {
        Ct(Lt, t, {
          value: e,
          configurable: !0,
          writable: !0
        });
      } catch (r) {
        Lt[t] = e;
      }
      return e;
    },
    Mt = "__core-js_shared__",
    Ft = o[Mt] || Rt(Mt, {}),
    Nt = Ft;
  (Dt.exports = function (t, e) {
    return Nt[t] || (Nt[t] = void 0 !== e ? e : {});
  })("versions", []).push({
    version: "3.21.1",
    mode: "pure",
    copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.21.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
  });
  var zt = X,
    qt = o.Object,
    Yt = function Yt(t) {
      return qt(zt(t));
    },
    Gt = Yt,
    Xt = m({}.hasOwnProperty),
    Ut = Object.hasOwn || function (t, e) {
      return Xt(Gt(t), e);
    },
    Wt = m,
    Vt = 0,
    Ht = Math.random(),
    $t = Wt(1..toString),
    Bt = function Bt(t) {
      return "Symbol(" + (void 0 === t ? "" : t) + ")_" + $t(++Vt + Ht, 36);
    },
    Jt = o,
    Kt = Dt.exports,
    Qt = Ut,
    Zt = Bt,
    te = ht,
    ee = pt,
    re = Kt("wks"),
    ne = Jt.Symbol,
    ie = ne && ne.for,
    oe = ee ? ne : ne && ne.withoutSetter || Zt,
    ae = function ae(t) {
      if (!Qt(re, t) || !te && "string" != typeof re[t]) {
        var e = "Symbol." + t;
        te && Qt(ne, t) ? re[t] = ne[t] : re[t] = ee && ie ? ie(e) : oe(e);
      }
      return re[t];
    },
    ue = T,
    se = $,
    ce = bt,
    fe = St,
    le = function le(t, e) {
      var r, n;
      if ("string" === e && jt(r = t.toString) && !Pt(n = At(r, t))) return n;
      if (jt(r = t.valueOf) && !Pt(n = At(r, t))) return n;
      if ("string" !== e && jt(r = t.toString) && !Pt(n = At(r, t))) return n;
      throw It("Can't convert object to primitive value");
    },
    he = ae,
    pe = o.TypeError,
    ve = he("toPrimitive"),
    de = function de(t, e) {
      if (!se(t) || ce(t)) return t;
      var r,
        n = fe(t, ve);
      if (n) {
        if (void 0 === e && (e = "default"), r = ue(n, t, e), !se(r) || ce(r)) return r;
        throw pe("Can't convert object to primitive value");
      }
      return void 0 === e && (e = "number"), le(t, e);
    },
    ye = bt,
    ge = function ge(t) {
      var e = de(t, "string");
      return ye(e) ? e : e + "";
    },
    me = $,
    be = o.document,
    _e = me(be) && me(be.createElement),
    we = function we(t) {
      return _e ? be.createElement(t) : {};
    },
    Oe = we,
    Ee = !w && !a(function () {
      return 7 != Object.defineProperty(Oe("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    }),
    Te = w,
    xe = T,
    ke = x,
    Se = I,
    Ae = V,
    je = ge,
    Pe = Ut,
    Ie = Ee,
    De = Object.getOwnPropertyDescriptor;
  _.f = Te ? De : function (t, e) {
    if (t = Ae(t), e = je(e), Ie) try {
      return De(t, e);
    } catch (t) {}
    if (Pe(t, e)) return Se(!xe(ke.f, t, e), t[e]);
  };
  var Le = a,
    Ce = b,
    Re = /#|\.prototype\./,
    Me = function Me(t, e) {
      var r = Ne[Fe(t)];
      return r == qe || r != ze && (Ce(e) ? Le(e) : !!e);
    },
    Fe = Me.normalize = function (t) {
      return String(t).replace(Re, ".").toLowerCase();
    },
    Ne = Me.data = {},
    ze = Me.NATIVE = "N",
    qe = Me.POLYFILL = "P",
    Ye = Me,
    Ge = xt,
    Xe = u,
    Ue = m(m.bind),
    We = function We(t, e) {
      return Ge(t), void 0 === e ? t : Xe ? Ue(t, e) : function () {
        return t.apply(e, arguments);
      };
    },
    Ve = {},
    He = w && a(function () {
      return 42 != Object.defineProperty(function () {}, "prototype", {
        value: 42,
        writable: !1
      }).prototype;
    }),
    $e = o,
    Be = $,
    Je = $e.String,
    Ke = $e.TypeError,
    Qe = function Qe(t) {
      if (Be(t)) return t;
      throw Ke(Je(t) + " is not an object");
    },
    Ze = w,
    tr = Ee,
    er = He,
    rr = Qe,
    nr = ge,
    ir = o.TypeError,
    or = Object.defineProperty,
    ar = Object.getOwnPropertyDescriptor,
    ur = "enumerable",
    sr = "configurable",
    cr = "writable";
  Ve.f = Ze ? er ? function (t, e, r) {
    if (rr(t), e = nr(e), rr(r), "function" == typeof t && "prototype" === e && "value" in r && cr in r && !r.writable) {
      var n = ar(t, e);
      n && n.writable && (t[e] = r.value, r = {
        configurable: sr in r ? r.configurable : n.configurable,
        enumerable: ur in r ? r.enumerable : n.enumerable,
        writable: !1
      });
    }
    return or(t, e, r);
  } : or : function (t, e, r) {
    if (rr(t), e = nr(e), rr(r), tr) try {
      return or(t, e, r);
    } catch (t) {}
    if ("get" in r || "set" in r) throw ir("Accessors not supported");
    return "value" in r && (t[e] = r.value), t;
  };
  var fr = Ve,
    lr = I,
    hr = w ? function (t, e, r) {
      return fr.f(t, e, lr(1, r));
    } : function (t, e, r) {
      return t[e] = r, t;
    },
    pr = o,
    vr = h,
    dr = m,
    yr = b,
    gr = _.f,
    mr = Ye,
    br = B,
    _r = We,
    wr = hr,
    Or = Ut,
    Er = function Er(t) {
      var e = function e(r, n, i) {
        if (this instanceof e) {
          switch (arguments.length) {
            case 0:
              return new t();
            case 1:
              return new t(r);
            case 2:
              return new t(r, n);
          }
          return new t(r, n, i);
        }
        return vr(t, this, arguments);
      };
      return e.prototype = t.prototype, e;
    },
    Tr = function Tr(t, e) {
      var r,
        n,
        i,
        o,
        a,
        u,
        s,
        c,
        f = t.target,
        l = t.global,
        h = t.stat,
        p = t.proto,
        v = l ? pr : h ? pr[f] : (pr[f] || {}).prototype,
        d = l ? br : br[f] || wr(br, f, {})[f],
        y = d.prototype;
      for (i in e) {
        r = !mr(l ? i : f + (h ? "." : "#") + i, t.forced) && v && Or(v, i), a = d[i], r && (u = t.noTargetGet ? (c = gr(v, i)) && c.value : v[i]), o = r && u ? u : e[i], r && typeof a == typeof o || (s = t.bind && r ? _r(o, pr) : t.wrap && r ? Er(o) : p && yr(o) ? dr(o) : o, (t.sham || o && o.sham || a && a.sham) && wr(s, "sham", !0), wr(d, i, s), p && (Or(br, n = f + "Prototype") || wr(br, n, {}), wr(br[n], i, o), t.real && y && !y[i] && wr(y, i, o)));
      }
    },
    xr = Tr,
    kr = w,
    Sr = Ve.f;
  xr({
    target: "Object",
    stat: !0,
    forced: Object.defineProperty !== Sr,
    sham: !kr
  }, {
    defineProperty: Sr
  });
  var Ar = B.Object,
    jr = n.exports = function (t, e, r) {
      return Ar.defineProperty(t, e, r);
    };
  Ar.defineProperty.sham && (jr.sham = !0);
  var Pr = n.exports,
    Ir = Pr;
  function Dr(t, e) {
    for (var r = 0; r < e.length; r++) {
      var n = e[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Ir(t, n.key, n);
    }
  }
  function Lr(t, e, r) {
    return e && Dr(t.prototype, e), r && Dr(t, r), Ir(t, "prototype", {
      writable: !1
    }), t;
  }
  function Cr(t, e, r) {
    return e in t ? Ir(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = r, t;
  }
  var Rr = m([].slice),
    Mr = m,
    Fr = xt,
    Nr = $,
    zr = Ut,
    qr = Rr,
    Yr = u,
    Gr = o.Function,
    Xr = Mr([].concat),
    Ur = Mr([].join),
    Wr = {},
    Vr = function Vr(t, e, r) {
      if (!zr(Wr, e)) {
        for (var n = [], i = 0; i < e; i++) {
          n[i] = "a[" + i + "]";
        }
        Wr[e] = Gr("C,a", "return new C(" + Ur(n, ",") + ")");
      }
      return Wr[e](t, r);
    },
    Hr = Yr ? Gr.bind : function (t) {
      var e = Fr(this),
        r = e.prototype,
        n = qr(arguments, 1),
        i = function i() {
          var r = Xr(n, qr(arguments));
          return this instanceof i ? Vr(e, r.length, r) : e.apply(t, r);
        };
      return Nr(r) && (i.prototype = r), i;
    },
    $r = Hr;
  Tr({
    target: "Function",
    proto: !0,
    forced: Function.bind !== $r
  }, {
    bind: $r
  });
  var Br = B,
    Jr = function Jr(t) {
      return Br[t + "Prototype"];
    },
    Kr = Jr("Function").bind,
    Qr = et,
    Zr = Kr,
    tn = Function.prototype,
    en = function en(t) {
      var e = t.bind;
      return t === tn || Qr(tn, t) && e === tn.bind ? Zr : e;
    },
    rn = Math.ceil,
    nn = Math.floor,
    on = function on(t) {
      var e = +t;
      return e != e || 0 === e ? 0 : (e > 0 ? nn : rn)(e);
    },
    an = on,
    un = Math.min,
    sn = function sn(t) {
      return t > 0 ? un(an(t), 9007199254740991) : 0;
    },
    cn = function cn(t) {
      return sn(t.length);
    },
    fn = xt,
    ln = Yt,
    hn = Y,
    pn = cn,
    vn = o.TypeError,
    dn = function dn(t) {
      return function (e, r, n, i) {
        fn(r);
        var o = ln(e),
          a = hn(o),
          u = pn(o),
          s = t ? u - 1 : 0,
          c = t ? -1 : 1;
        if (n < 2) for (;;) {
          if (s in a) {
            i = a[s], s += c;
            break;
          }
          if (s += c, t ? s < 0 : u <= s) throw vn("Reduce of empty array with no initial value");
        }
        for (; t ? s >= 0 : u > s; s += c) {
          s in a && (i = r(i, a[s], s, o));
        }
        return i;
      };
    },
    yn = {
      left: dn(!1),
      right: dn(!0)
    },
    gn = a,
    mn = function mn(t, e) {
      var r = [][t];
      return !!r && gn(function () {
        r.call(null, e || function () {
          return 1;
        }, 1);
      });
    },
    bn = "process" == R(o.process),
    _n = yn.left,
    wn = ct,
    On = bn;
  Tr({
    target: "Array",
    proto: !0,
    forced: !mn("reduce") || !On && wn > 79 && wn < 83
  }, {
    reduce: function reduce(t) {
      var e = arguments.length;
      return _n(this, t, e, e > 1 ? arguments[1] : void 0);
    }
  });
  var En = Jr("Array").reduce,
    Tn = et,
    xn = En,
    kn = Array.prototype,
    Sn = function Sn(t) {
      var e = t.reduce;
      return t === kn || Tn(kn, t) && e === kn.reduce ? xn : e;
    },
    An = R,
    jn = Array.isArray || function (t) {
      return "Array" == An(t);
    },
    Pn = {};
  Pn[ae("toStringTag")] = "z";
  var In = "[object z]" === String(Pn),
    Dn = o,
    Ln = In,
    Cn = b,
    Rn = R,
    Mn = ae("toStringTag"),
    Fn = Dn.Object,
    Nn = "Arguments" == Rn(function () {
      return arguments;
    }()),
    zn = Ln ? Rn : function (t) {
      var e, r, n;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      }(e = Fn(t), Mn)) ? r : Nn ? Rn(e) : "Object" == (n = Rn(e)) && Cn(e.callee) ? "Arguments" : n;
    },
    qn = b,
    Yn = Ft,
    Gn = m(Function.toString);
  qn(Yn.inspectSource) || (Yn.inspectSource = function (t) {
    return Gn(t);
  });
  var Xn = Yn.inspectSource,
    Un = m,
    Wn = a,
    Vn = b,
    Hn = zn,
    $n = Xn,
    Bn = function Bn() {},
    Jn = [],
    Kn = tt("Reflect", "construct"),
    Qn = /^\s*(?:class|function)\b/,
    Zn = Un(Qn.exec),
    ti = !Qn.exec(Bn),
    ei = function ei(t) {
      if (!Vn(t)) return !1;
      try {
        return Kn(Bn, Jn, t), !0;
      } catch (t) {
        return !1;
      }
    },
    ri = function ri(t) {
      if (!Vn(t)) return !1;
      switch (Hn(t)) {
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
          return !1;
      }
      try {
        return ti || !!Zn(Qn, $n(t));
      } catch (t) {
        return !0;
      }
    };
  ri.sham = !0;
  var ni = !Kn || Wn(function () {
      var t;
      return ei(ei.call) || !ei(Object) || !ei(function () {
        t = !0;
      }) || t;
    }) ? ri : ei,
    ii = o,
    oi = jn,
    ai = ni,
    ui = $,
    si = ae("species"),
    ci = ii.Array,
    fi = function fi(t) {
      var e;
      return oi(t) && (e = t.constructor, (ai(e) && (e === ci || oi(e.prototype)) || ui(e) && null === (e = e[si])) && (e = void 0)), void 0 === e ? ci : e;
    },
    li = function li(t, e) {
      return new (fi(t))(0 === e ? 0 : e);
    },
    hi = We,
    pi = Y,
    vi = Yt,
    di = cn,
    yi = li,
    gi = m([].push),
    mi = function mi(t) {
      var e = 1 == t,
        r = 2 == t,
        n = 3 == t,
        i = 4 == t,
        o = 6 == t,
        a = 7 == t,
        u = 5 == t || o;
      return function (s, c, f, l) {
        for (var h, p, v = vi(s), d = pi(v), y = hi(c, f), g = di(d), m = 0, b = l || yi, _ = e ? b(s, g) : r || a ? b(s, 0) : void 0; g > m; m++) {
          if ((u || m in d) && (p = y(h = d[m], m, v), t)) if (e) _[m] = p;else if (p) switch (t) {
            case 3:
              return !0;
            case 5:
              return h;
            case 6:
              return m;
            case 2:
              gi(_, h);
          } else switch (t) {
            case 4:
              return !1;
            case 7:
              gi(_, h);
          }
        }
        return o ? -1 : n || i ? i : _;
      };
    },
    bi = {
      forEach: mi(0),
      map: mi(1),
      filter: mi(2),
      some: mi(3),
      every: mi(4),
      find: mi(5),
      findIndex: mi(6),
      filterReject: mi(7)
    },
    _i = a,
    wi = ct,
    Oi = ae("species"),
    Ei = function Ei(t) {
      return wi >= 51 || !_i(function () {
        var e = [];
        return (e.constructor = {})[Oi] = function () {
          return {
            foo: 1
          };
        }, 1 !== e[t](Boolean).foo;
      });
    },
    Ti = bi.filter;
  Tr({
    target: "Array",
    proto: !0,
    forced: !Ei("filter")
  }, {
    filter: function filter(t) {
      return Ti(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var xi = Jr("Array").filter,
    ki = et,
    Si = xi,
    Ai = Array.prototype,
    ji = function ji(t) {
      var e = t.filter;
      return t === Ai || ki(Ai, t) && e === Ai.filter ? Si : e;
    },
    Pi = bi.map;
  Tr({
    target: "Array",
    proto: !0,
    forced: !Ei("map")
  }, {
    map: function map(t) {
      return Pi(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var Ii = Jr("Array").map,
    Di = et,
    Li = Ii,
    Ci = Array.prototype,
    Ri = function Ri(t) {
      var e = t.map;
      return t === Ci || Di(Ci, t) && e === Ci.map ? Li : e;
    },
    Mi = jn,
    Fi = cn,
    Ni = We,
    zi = o.TypeError,
    qi = function qi(t, e, r, n, i, o, a, u) {
      for (var s, c, f = i, l = 0, h = !!a && Ni(a, u); l < n;) {
        if (l in r) {
          if (s = h ? h(r[l], l, e) : r[l], o > 0 && Mi(s)) c = Fi(s), f = qi(t, e, s, c, f, o - 1) - 1;else {
            if (f >= 9007199254740991) throw zi("Exceed the acceptable array length");
            t[f] = s;
          }
          f++;
        }
        l++;
      }
      return f;
    },
    Yi = qi,
    Gi = xt,
    Xi = Yt,
    Ui = cn,
    Wi = li;
  Tr({
    target: "Array",
    proto: !0
  }, {
    flatMap: function flatMap(t) {
      var e,
        r = Xi(this),
        n = Ui(r);
      return Gi(t), (e = Wi(r, 0)).length = Yi(e, r, r, n, 0, 1, t, arguments.length > 1 ? arguments[1] : void 0), e;
    }
  });
  var Vi = Jr("Array").flatMap,
    Hi = et,
    $i = Vi,
    Bi = Array.prototype,
    Ji = function Ji(t) {
      var e = t.flatMap;
      return t === Bi || Hi(Bi, t) && e === Bi.flatMap ? $i : e;
    };
  var Ki,
    Qi,
    Zi,
    to = function () {
      function t(r, n, i) {
        var o, a, u;
        e(this, t), Cr(this, "_source", void 0), Cr(this, "_transformers", void 0), Cr(this, "_target", void 0), Cr(this, "_listeners", {
          add: en(o = this._add).call(o, this),
          remove: en(a = this._remove).call(a, this),
          update: en(u = this._update).call(u, this)
        }), this._source = r, this._transformers = n, this._target = i;
      }
      return Lr(t, [{
        key: "all",
        value: function value() {
          return this._target.update(this._transformItems(this._source.get())), this;
        }
      }, {
        key: "start",
        value: function value() {
          return this._source.on("add", this._listeners.add), this._source.on("remove", this._listeners.remove), this._source.on("update", this._listeners.update), this;
        }
      }, {
        key: "stop",
        value: function value() {
          return this._source.off("add", this._listeners.add), this._source.off("remove", this._listeners.remove), this._source.off("update", this._listeners.update), this;
        }
      }, {
        key: "_transformItems",
        value: function value(t) {
          var e;
          return Sn(e = this._transformers).call(e, function (t, e) {
            return e(t);
          }, t);
        }
      }, {
        key: "_add",
        value: function value(t, e) {
          null != e && this._target.add(this._transformItems(this._source.get(e.items)));
        }
      }, {
        key: "_update",
        value: function value(t, e) {
          null != e && this._target.update(this._transformItems(this._source.get(e.items)));
        }
      }, {
        key: "_remove",
        value: function value(t, e) {
          null != e && this._target.remove(this._transformItems(e.oldData));
        }
      }]), t;
    }(),
    eo = function () {
      function t(r) {
        e(this, t), Cr(this, "_source", void 0), Cr(this, "_transformers", []), this._source = r;
      }
      return Lr(t, [{
        key: "filter",
        value: function value(t) {
          return this._transformers.push(function (e) {
            return ji(e).call(e, t);
          }), this;
        }
      }, {
        key: "map",
        value: function value(t) {
          return this._transformers.push(function (e) {
            return Ri(e).call(e, t);
          }), this;
        }
      }, {
        key: "flatMap",
        value: function value(t) {
          return this._transformers.push(function (e) {
            return Ji(e).call(e, t);
          }), this;
        }
      }, {
        key: "to",
        value: function value(t) {
          return new to(this._source, this._transformers, t);
        }
      }]), t;
    }(),
    ro = zn,
    no = o.String,
    io = function io(t) {
      if ("Symbol" === ro(t)) throw TypeError("Cannot convert a Symbol value to a string");
      return no(t);
    },
    oo = m,
    ao = on,
    uo = io,
    so = X,
    co = oo("".charAt),
    fo = oo("".charCodeAt),
    lo = oo("".slice),
    ho = function ho(t) {
      return function (e, r) {
        var n,
          i,
          o = uo(so(e)),
          a = ao(r),
          u = o.length;
        return a < 0 || a >= u ? t ? "" : void 0 : (n = fo(o, a)) < 55296 || n > 56319 || a + 1 === u || (i = fo(o, a + 1)) < 56320 || i > 57343 ? t ? co(o, a) : n : t ? lo(o, a, a + 2) : i - 56320 + (n - 55296 << 10) + 65536;
      };
    },
    po = {
      codeAt: ho(!1),
      charAt: ho(!0)
    },
    vo = b,
    yo = Xn,
    go = o.WeakMap,
    mo = vo(go) && /native code/.test(yo(go)),
    bo = Dt.exports,
    _o = Bt,
    wo = bo("keys"),
    Oo = function Oo(t) {
      return wo[t] || (wo[t] = _o(t));
    },
    Eo = {},
    To = mo,
    xo = o,
    ko = m,
    So = $,
    Ao = hr,
    jo = Ut,
    Po = Ft,
    Io = Oo,
    Do = Eo,
    Lo = "Object already initialized",
    Co = xo.TypeError,
    Ro = xo.WeakMap;
  if (To || Po.state) {
    var Mo = Po.state || (Po.state = new Ro()),
      Fo = ko(Mo.get),
      No = ko(Mo.has),
      zo = ko(Mo.set);
    Ki = function Ki(t, e) {
      if (No(Mo, t)) throw new Co(Lo);
      return e.facade = t, zo(Mo, t, e), e;
    }, Qi = function Qi(t) {
      return Fo(Mo, t) || {};
    }, Zi = function Zi(t) {
      return No(Mo, t);
    };
  } else {
    var qo = Io("state");
    Do[qo] = !0, Ki = function Ki(t, e) {
      if (jo(t, qo)) throw new Co(Lo);
      return e.facade = t, Ao(t, qo, e), e;
    }, Qi = function Qi(t) {
      return jo(t, qo) ? t[qo] : {};
    }, Zi = function Zi(t) {
      return jo(t, qo);
    };
  }
  var Yo = {
      set: Ki,
      get: Qi,
      has: Zi,
      enforce: function enforce(t) {
        return Zi(t) ? Qi(t) : Ki(t, {});
      },
      getterFor: function getterFor(t) {
        return function (e) {
          var r;
          if (!So(e) || (r = Qi(e)).type !== t) throw Co("Incompatible receiver, " + t + " required");
          return r;
        };
      }
    },
    Go = w,
    Xo = Ut,
    Uo = Function.prototype,
    Wo = Go && Object.getOwnPropertyDescriptor,
    Vo = Xo(Uo, "name"),
    Ho = {
      EXISTS: Vo,
      PROPER: Vo && "something" === function () {}.name,
      CONFIGURABLE: Vo && (!Go || Go && Wo(Uo, "name").configurable)
    },
    $o = {},
    Bo = on,
    Jo = Math.max,
    Ko = Math.min,
    Qo = function Qo(t, e) {
      var r = Bo(t);
      return r < 0 ? Jo(r + e, 0) : Ko(r, e);
    },
    Zo = V,
    ta = Qo,
    ea = cn,
    ra = function ra(t) {
      return function (e, r, n) {
        var i,
          o = Zo(e),
          a = ea(o),
          u = ta(n, a);
        if (t && r != r) {
          for (; a > u;) {
            if ((i = o[u++]) != i) return !0;
          }
        } else for (; a > u; u++) {
          if ((t || u in o) && o[u] === r) return t || u || 0;
        }
        return !t && -1;
      };
    },
    na = {
      includes: ra(!0),
      indexOf: ra(!1)
    },
    ia = Ut,
    oa = V,
    aa = na.indexOf,
    ua = Eo,
    sa = m([].push),
    ca = function ca(t, e) {
      var r,
        n = oa(t),
        i = 0,
        o = [];
      for (r in n) {
        !ia(ua, r) && ia(n, r) && sa(o, r);
      }
      for (; e.length > i;) {
        ia(n, r = e[i++]) && (~aa(o, r) || sa(o, r));
      }
      return o;
    },
    fa = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    la = ca,
    ha = fa,
    pa = Object.keys || function (t) {
      return la(t, ha);
    },
    va = w,
    da = He,
    ya = Ve,
    ga = Qe,
    ma = V,
    ba = pa;
  $o.f = va && !da ? Object.defineProperties : function (t, e) {
    ga(t);
    for (var r, n = ma(e), i = ba(e), o = i.length, a = 0; o > a;) {
      ya.f(t, r = i[a++], n[r]);
    }
    return t;
  };
  var _a,
    wa = tt("document", "documentElement"),
    Oa = Qe,
    Ea = $o,
    Ta = fa,
    xa = Eo,
    ka = wa,
    Sa = we,
    Aa = Oo("IE_PROTO"),
    ja = function ja() {},
    Pa = function Pa(t) {
      return "<script>" + t + "</" + "script>";
    },
    Ia = function Ia(t) {
      t.write(Pa("")), t.close();
      var e = t.parentWindow.Object;
      return t = null, e;
    },
    _Da = function Da() {
      try {
        _a = new ActiveXObject("htmlfile");
      } catch (t) {}
      var t, e;
      _Da = "undefined" != typeof document ? document.domain && _a ? Ia(_a) : ((e = Sa("iframe")).style.display = "none", ka.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(Pa("document.F=Object")), t.close(), t.F) : Ia(_a);
      for (var r = Ta.length; r--;) {
        delete _Da.prototype[Ta[r]];
      }
      return _Da();
    };
  xa[Aa] = !0;
  var La,
    Ca,
    Ra,
    Ma = Object.create || function (t, e) {
      var r;
      return null !== t ? (ja.prototype = Oa(t), r = new ja(), ja.prototype = null, r[Aa] = t) : r = _Da(), void 0 === e ? r : Ea.f(r, e);
    },
    Fa = !a(function () {
      function t() {}
      return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
    }),
    Na = o,
    za = Ut,
    qa = b,
    Ya = Yt,
    Ga = Fa,
    Xa = Oo("IE_PROTO"),
    Ua = Na.Object,
    Wa = Ua.prototype,
    Va = Ga ? Ua.getPrototypeOf : function (t) {
      var e = Ya(t);
      if (za(e, Xa)) return e[Xa];
      var r = e.constructor;
      return qa(r) && e instanceof r ? r.prototype : e instanceof Ua ? Wa : null;
    },
    Ha = hr,
    $a = function $a(t, e, r, n) {
      n && n.enumerable ? t[e] = r : Ha(t, e, r);
    },
    Ba = a,
    Ja = b,
    Ka = Ma,
    Qa = Va,
    Za = $a,
    tu = ae("iterator"),
    eu = !1;
  [].keys && ("next" in (Ra = [].keys()) ? (Ca = Qa(Qa(Ra))) !== Object.prototype && (La = Ca) : eu = !0);
  var ru = null == La || Ba(function () {
    var t = {};
    return La[tu].call(t) !== t;
  });
  Ja((La = ru ? {} : Ka(La))[tu]) || Za(La, tu, function () {
    return this;
  });
  var nu = {
      IteratorPrototype: La,
      BUGGY_SAFARI_ITERATORS: eu
    },
    iu = zn,
    ou = In ? {}.toString : function () {
      return "[object " + iu(this) + "]";
    },
    au = In,
    uu = Ve.f,
    su = hr,
    cu = Ut,
    fu = ou,
    lu = ae("toStringTag"),
    hu = function hu(t, e, r, n) {
      if (t) {
        var i = r ? t : t.prototype;
        cu(i, lu) || uu(i, lu, {
          configurable: !0,
          value: e
        }), n && !au && su(i, "toString", fu);
      }
    },
    pu = {},
    vu = nu.IteratorPrototype,
    du = Ma,
    yu = I,
    gu = hu,
    mu = pu,
    bu = function bu() {
      return this;
    },
    _u = o,
    wu = b,
    Ou = _u.String,
    Eu = _u.TypeError,
    Tu = m,
    xu = Qe,
    ku = function ku(t) {
      if ("object" == typeof t || wu(t)) return t;
      throw Eu("Can't set " + Ou(t) + " as a prototype");
    },
    Su = Object.setPrototypeOf || ("__proto__" in {} ? function () {
      var t,
        e = !1,
        r = {};
      try {
        (t = Tu(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set))(r, []), e = r instanceof Array;
      } catch (t) {}
      return function (r, n) {
        return xu(r), ku(n), e ? t(r, n) : r.__proto__ = n, r;
      };
    }() : void 0),
    Au = Tr,
    ju = T,
    Pu = function Pu(t, e, r, n) {
      var i = e + " Iterator";
      return t.prototype = du(vu, {
        next: yu(+!n, r)
      }), gu(t, i, !1, !0), mu[i] = bu, t;
    },
    Iu = Va,
    Du = hu,
    Lu = $a,
    Cu = pu,
    Ru = Ho.PROPER,
    Mu = nu.BUGGY_SAFARI_ITERATORS,
    Fu = ae("iterator"),
    Nu = "keys",
    zu = "values",
    qu = "entries",
    Yu = function Yu() {
      return this;
    },
    Gu = function Gu(t, e, r, n, i, o, a) {
      Pu(r, e, n);
      var u,
        s,
        c,
        f = function f(t) {
          if (t === i && d) return d;
          if (!Mu && t in p) return p[t];
          switch (t) {
            case Nu:
            case zu:
            case qu:
              return function () {
                return new r(this, t);
              };
          }
          return function () {
            return new r(this);
          };
        },
        l = e + " Iterator",
        h = !1,
        p = t.prototype,
        v = p[Fu] || p["@@iterator"] || i && p[i],
        d = !Mu && v || f(i),
        y = "Array" == e && p.entries || v;
      if (y && (u = Iu(y.call(new t()))) !== Object.prototype && u.next && (Du(u, l, !0, !0), Cu[l] = Yu), Ru && i == zu && v && v.name !== zu && (h = !0, d = function d() {
        return ju(v, this);
      }), i) if (s = {
        values: f(zu),
        keys: o ? d : f(Nu),
        entries: f(qu)
      }, a) for (c in s) {
        (Mu || h || !(c in p)) && Lu(p, c, s[c]);
      } else Au({
        target: e,
        proto: !0,
        forced: Mu || h
      }, s);
      return a && p[Fu] !== d && Lu(p, Fu, d, {
        name: i
      }), Cu[e] = d, s;
    },
    Xu = po.charAt,
    Uu = io,
    Wu = Yo,
    Vu = Gu,
    Hu = "String Iterator",
    $u = Wu.set,
    Bu = Wu.getterFor(Hu);
  Vu(String, "String", function (t) {
    $u(this, {
      type: Hu,
      string: Uu(t),
      index: 0
    });
  }, function () {
    var t,
      e = Bu(this),
      r = e.string,
      n = e.index;
    return n >= r.length ? {
      value: void 0,
      done: !0
    } : (t = Xu(r, n), e.index += t.length, {
      value: t,
      done: !1
    });
  });
  var Ju = T,
    Ku = Qe,
    Qu = St,
    Zu = function Zu(t, e, r) {
      var n, i;
      Ku(t);
      try {
        if (!(n = Qu(t, "return"))) {
          if ("throw" === e) throw r;
          return r;
        }
        n = Ju(n, t);
      } catch (t) {
        i = !0, n = t;
      }
      if ("throw" === e) throw r;
      if (i) throw n;
      return Ku(n), r;
    },
    ts = Qe,
    es = Zu,
    rs = pu,
    ns = ae("iterator"),
    is = Array.prototype,
    os = function os(t) {
      return void 0 !== t && (rs.Array === t || is[ns] === t);
    },
    as = ge,
    us = Ve,
    ss = I,
    cs = function cs(t, e, r) {
      var n = as(e);
      n in t ? us.f(t, n, ss(0, r)) : t[n] = r;
    },
    fs = zn,
    ls = St,
    hs = pu,
    ps = ae("iterator"),
    vs = function vs(t) {
      if (null != t) return ls(t, ps) || ls(t, "@@iterator") || hs[fs(t)];
    },
    ds = T,
    ys = xt,
    gs = Qe,
    ms = wt,
    bs = vs,
    _s = o.TypeError,
    ws = function ws(t, e) {
      var r = arguments.length < 2 ? bs(t) : e;
      if (ys(r)) return gs(ds(r, t));
      throw _s(ms(t) + " is not iterable");
    },
    Os = We,
    Es = T,
    Ts = Yt,
    xs = function xs(t, e, r, n) {
      try {
        return n ? e(ts(r)[0], r[1]) : e(r);
      } catch (e) {
        es(t, "throw", e);
      }
    },
    ks = os,
    Ss = ni,
    As = cn,
    js = cs,
    Ps = ws,
    Is = vs,
    Ds = o.Array,
    Ls = ae("iterator"),
    Cs = !1;
  try {
    var Rs = 0,
      Ms = {
        next: function next() {
          return {
            done: !!Rs++
          };
        },
        return: function _return() {
          Cs = !0;
        }
      };
    Ms[Ls] = function () {
      return this;
    }, Array.from(Ms, function () {
      throw 2;
    });
  } catch (t) {}
  var Fs = function Fs(t) {
      var e = Ts(t),
        r = Ss(this),
        n = arguments.length,
        i = n > 1 ? arguments[1] : void 0,
        o = void 0 !== i;
      o && (i = Os(i, n > 2 ? arguments[2] : void 0));
      var a,
        u,
        s,
        c,
        f,
        l,
        h = Is(e),
        p = 0;
      if (!h || this == Ds && ks(h)) for (a = As(e), u = r ? new this(a) : Ds(a); a > p; p++) {
        l = o ? i(e[p], p) : e[p], js(u, p, l);
      } else for (f = (c = Ps(e, h)).next, u = r ? new this() : []; !(s = Es(f, c)).done; p++) {
        l = o ? xs(c, i, [s.value, p], !0) : s.value, js(u, p, l);
      }
      return u.length = p, u;
    },
    Ns = function Ns(t, e) {
      if (!e && !Cs) return !1;
      var r = !1;
      try {
        var n = {};
        n[Ls] = function () {
          return {
            next: function next() {
              return {
                done: r = !0
              };
            }
          };
        }, t(n);
      } catch (t) {}
      return r;
    };
  Tr({
    target: "Array",
    stat: !0,
    forced: !Ns(function (t) {
      Array.from(t);
    })
  }, {
    from: Fs
  });
  var zs = B.Array.from,
    qs = zs,
    Ys = V,
    Gs = pu,
    Xs = Yo;
  Ve.f;
  var Us = Gu,
    Ws = "Array Iterator",
    Vs = Xs.set,
    Hs = Xs.getterFor(Ws);
  Us(Array, "Array", function (t, e) {
    Vs(this, {
      type: Ws,
      target: Ys(t),
      index: 0,
      kind: e
    });
  }, function () {
    var t = Hs(this),
      e = t.target,
      r = t.kind,
      n = t.index++;
    return !e || n >= e.length ? (t.target = void 0, {
      value: void 0,
      done: !0
    }) : "keys" == r ? {
      value: n,
      done: !1
    } : "values" == r ? {
      value: e[n],
      done: !1
    } : {
      value: [n, e[n]],
      done: !1
    };
  }, "values"), Gs.Arguments = Gs.Array;
  var $s = vs,
    Bs = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    },
    Js = o,
    Ks = zn,
    Qs = hr,
    Zs = pu,
    tc = ae("toStringTag");
  for (var ec in Bs) {
    var rc = Js[ec],
      nc = rc && rc.prototype;
    nc && Ks(nc) !== tc && Qs(nc, tc, ec), Zs[ec] = Zs.Array;
  }
  var ic = $s,
    oc = {},
    ac = ca,
    uc = fa.concat("length", "prototype");
  oc.f = Object.getOwnPropertyNames || function (t) {
    return ac(t, uc);
  };
  var sc = {},
    cc = Qo,
    fc = cn,
    lc = cs,
    hc = o.Array,
    pc = Math.max,
    vc = function vc(t, e, r) {
      for (var n = fc(t), i = cc(e, n), o = cc(void 0 === r ? n : r, n), a = hc(pc(o - i, 0)), u = 0; i < o; i++, u++) {
        lc(a, u, t[i]);
      }
      return a.length = u, a;
    },
    dc = R,
    yc = V,
    gc = oc.f,
    mc = vc,
    bc = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
  sc.f = function (t) {
    return bc && "Window" == dc(t) ? function (t) {
      try {
        return gc(t);
      } catch (t) {
        return mc(bc);
      }
    }(t) : gc(yc(t));
  };
  var _c = {};
  _c.f = Object.getOwnPropertySymbols;
  var wc = {},
    Oc = ae;
  wc.f = Oc;
  var Ec = B,
    Tc = Ut,
    xc = wc,
    kc = Ve.f,
    Sc = function Sc(t) {
      var e = Ec.Symbol || (Ec.Symbol = {});
      Tc(e, t) || kc(e, t, {
        value: xc.f(t)
      });
    },
    Ac = Tr,
    jc = o,
    Pc = tt,
    Ic = h,
    Dc = T,
    Lc = m,
    Cc = w,
    Rc = ht,
    Mc = a,
    Fc = Ut,
    Nc = jn,
    zc = b,
    qc = $,
    Yc = et,
    Gc = bt,
    Xc = Qe,
    Uc = Yt,
    Wc = V,
    Vc = ge,
    Hc = io,
    $c = I,
    Bc = Ma,
    Jc = pa,
    Kc = oc,
    Qc = sc,
    Zc = _c,
    tf = _,
    ef = Ve,
    rf = $o,
    nf = x,
    of = Rr,
    af = $a,
    uf = Dt.exports,
    sf = Eo,
    cf = Bt,
    ff = ae,
    lf = wc,
    hf = Sc,
    pf = hu,
    vf = Yo,
    df = bi.forEach,
    yf = Oo("hidden"),
    gf = "Symbol",
    mf = ff("toPrimitive"),
    bf = vf.set,
    _f = vf.getterFor(gf),
    wf = Object.prototype,
    Of = jc.Symbol,
    Ef = Of && Of.prototype,
    Tf = jc.TypeError,
    xf = jc.QObject,
    kf = Pc("JSON", "stringify"),
    Sf = tf.f,
    Af = ef.f,
    jf = Qc.f,
    Pf = nf.f,
    If = Lc([].push),
    Df = uf("symbols"),
    Lf = uf("op-symbols"),
    Cf = uf("string-to-symbol-registry"),
    Rf = uf("symbol-to-string-registry"),
    Mf = uf("wks"),
    Ff = !xf || !xf.prototype || !xf.prototype.findChild,
    Nf = Cc && Mc(function () {
      return 7 != Bc(Af({}, "a", {
        get: function get() {
          return Af(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (t, e, r) {
      var n = Sf(wf, e);
      n && delete wf[e], Af(t, e, r), n && t !== wf && Af(wf, e, n);
    } : Af,
    zf = function zf(t, e) {
      var r = Df[t] = Bc(Ef);
      return bf(r, {
        type: gf,
        tag: t,
        description: e
      }), Cc || (r.description = e), r;
    },
    qf = function qf(t, e, r) {
      t === wf && qf(Lf, e, r), Xc(t);
      var n = Vc(e);
      return Xc(r), Fc(Df, n) ? (r.enumerable ? (Fc(t, yf) && t[yf][n] && (t[yf][n] = !1), r = Bc(r, {
        enumerable: $c(0, !1)
      })) : (Fc(t, yf) || Af(t, yf, $c(1, {})), t[yf][n] = !0), Nf(t, n, r)) : Af(t, n, r);
    },
    Yf = function Yf(t, e) {
      Xc(t);
      var r = Wc(e),
        n = Jc(r).concat(Wf(r));
      return df(n, function (e) {
        Cc && !Dc(Gf, r, e) || qf(t, e, r[e]);
      }), t;
    },
    Gf = function Gf(t) {
      var e = Vc(t),
        r = Dc(Pf, this, e);
      return !(this === wf && Fc(Df, e) && !Fc(Lf, e)) && (!(r || !Fc(this, e) || !Fc(Df, e) || Fc(this, yf) && this[yf][e]) || r);
    },
    Xf = function Xf(t, e) {
      var r = Wc(t),
        n = Vc(e);
      if (r !== wf || !Fc(Df, n) || Fc(Lf, n)) {
        var i = Sf(r, n);
        return !i || !Fc(Df, n) || Fc(r, yf) && r[yf][n] || (i.enumerable = !0), i;
      }
    },
    Uf = function Uf(t) {
      var e = jf(Wc(t)),
        r = [];
      return df(e, function (t) {
        Fc(Df, t) || Fc(sf, t) || If(r, t);
      }), r;
    },
    Wf = function Wf(t) {
      var e = t === wf,
        r = jf(e ? Lf : Wc(t)),
        n = [];
      return df(r, function (t) {
        !Fc(Df, t) || e && !Fc(wf, t) || If(n, Df[t]);
      }), n;
    };
  if (Rc || (Of = function Of() {
    if (Yc(Ef, this)) throw Tf("Symbol is not a constructor");
    var t = arguments.length && void 0 !== arguments[0] ? Hc(arguments[0]) : void 0,
      e = cf(t),
      r = function r(t) {
        this === wf && Dc(r, Lf, t), Fc(this, yf) && Fc(this[yf], e) && (this[yf][e] = !1), Nf(this, e, $c(1, t));
      };
    return Cc && Ff && Nf(wf, e, {
      configurable: !0,
      set: r
    }), zf(e, t);
  }, af(Ef = Of.prototype, "toString", function () {
    return _f(this).tag;
  }), af(Of, "withoutSetter", function (t) {
    return zf(cf(t), t);
  }), nf.f = Gf, ef.f = qf, rf.f = Yf, tf.f = Xf, Kc.f = Qc.f = Uf, Zc.f = Wf, lf.f = function (t) {
    return zf(ff(t), t);
  }, Cc && Af(Ef, "description", {
    configurable: !0,
    get: function get() {
      return _f(this).description;
    }
  })), Ac({
    global: !0,
    wrap: !0,
    forced: !Rc,
    sham: !Rc
  }, {
    Symbol: Of
  }), df(Jc(Mf), function (t) {
    hf(t);
  }), Ac({
    target: gf,
    stat: !0,
    forced: !Rc
  }, {
    for: function _for(t) {
      var e = Hc(t);
      if (Fc(Cf, e)) return Cf[e];
      var r = Of(e);
      return Cf[e] = r, Rf[r] = e, r;
    },
    keyFor: function keyFor(t) {
      if (!Gc(t)) throw Tf(t + " is not a symbol");
      if (Fc(Rf, t)) return Rf[t];
    },
    useSetter: function useSetter() {
      Ff = !0;
    },
    useSimple: function useSimple() {
      Ff = !1;
    }
  }), Ac({
    target: "Object",
    stat: !0,
    forced: !Rc,
    sham: !Cc
  }, {
    create: function create(t, e) {
      return void 0 === e ? Bc(t) : Yf(Bc(t), e);
    },
    defineProperty: qf,
    defineProperties: Yf,
    getOwnPropertyDescriptor: Xf
  }), Ac({
    target: "Object",
    stat: !0,
    forced: !Rc
  }, {
    getOwnPropertyNames: Uf,
    getOwnPropertySymbols: Wf
  }), Ac({
    target: "Object",
    stat: !0,
    forced: Mc(function () {
      Zc.f(1);
    })
  }, {
    getOwnPropertySymbols: function getOwnPropertySymbols(t) {
      return Zc.f(Uc(t));
    }
  }), kf) {
    var Vf = !Rc || Mc(function () {
      var t = Of();
      return "[null]" != kf([t]) || "{}" != kf({
        a: t
      }) || "{}" != kf(Object(t));
    });
    Ac({
      target: "JSON",
      stat: !0,
      forced: Vf
    }, {
      stringify: function stringify(t, e, r) {
        var n = of(arguments),
          i = e;
        if ((qc(e) || void 0 !== t) && !Gc(t)) return Nc(e) || (e = function e(t, _e2) {
          if (zc(i) && (_e2 = Dc(i, this, t, _e2)), !Gc(_e2)) return _e2;
        }), n[1] = e, Ic(kf, null, n);
      }
    });
  }
  if (!Ef[mf]) {
    var Hf = Ef.valueOf;
    af(Ef, mf, function (t) {
      return Dc(Hf, this);
    });
  }
  pf(Of, gf), sf[yf] = !0;
  var $f = B.Object.getOwnPropertySymbols,
    Bf = {
      exports: {}
    },
    Jf = Tr,
    Kf = a,
    Qf = V,
    Zf = _.f,
    tl = w,
    el = Kf(function () {
      Zf(1);
    });
  Jf({
    target: "Object",
    stat: !0,
    forced: !tl || el,
    sham: !tl
  }, {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
      return Zf(Qf(t), e);
    }
  });
  var rl = B.Object,
    nl = Bf.exports = function (t, e) {
      return rl.getOwnPropertyDescriptor(t, e);
    };
  rl.getOwnPropertyDescriptor.sham && (nl.sham = !0);
  var il = Bf.exports,
    ol = tt,
    al = oc,
    ul = _c,
    sl = Qe,
    cl = m([].concat),
    fl = ol("Reflect", "ownKeys") || function (t) {
      var e = al.f(sl(t)),
        r = ul.f;
      return r ? cl(e, r(t)) : e;
    },
    ll = fl,
    hl = V,
    pl = _,
    vl = cs;
  Tr({
    target: "Object",
    stat: !0,
    sham: !w
  }, {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
      for (var e, r, n = hl(t), i = pl.f, o = ll(n), a = {}, u = 0; o.length > u;) {
        void 0 !== (r = i(n, e = o[u++])) && vl(a, e, r);
      }
      return a;
    }
  });
  var dl = B.Object.getOwnPropertyDescriptors,
    yl = {
      exports: {}
    },
    gl = Tr,
    ml = w,
    bl = $o.f;
  gl({
    target: "Object",
    stat: !0,
    forced: Object.defineProperties !== bl,
    sham: !ml
  }, {
    defineProperties: bl
  });
  var _l = B.Object,
    wl = yl.exports = function (t, e) {
      return _l.defineProperties(t, e);
    };
  _l.defineProperties.sham && (wl.sham = !0);
  var Ol = yl.exports,
    El = Pr;
  Tr({
    target: "Array",
    stat: !0
  }, {
    isArray: jn
  });
  var Tl = B.Array.isArray,
    xl = Tl;
  var kl = Tr,
    Sl = o,
    Al = a,
    jl = jn,
    Pl = $,
    Il = Yt,
    Dl = cn,
    Ll = cs,
    Cl = li,
    Rl = Ei,
    Ml = ct,
    Fl = ae("isConcatSpreadable"),
    Nl = 9007199254740991,
    zl = "Maximum allowed index exceeded",
    ql = Sl.TypeError,
    Yl = Ml >= 51 || !Al(function () {
      var t = [];
      return t[Fl] = !1, t.concat()[0] !== t;
    }),
    Gl = Rl("concat"),
    Xl = function Xl(t) {
      if (!Pl(t)) return !1;
      var e = t[Fl];
      return void 0 !== e ? !!e : jl(t);
    };
  kl({
    target: "Array",
    proto: !0,
    forced: !Yl || !Gl
  }, {
    concat: function concat(t) {
      var e,
        r,
        n,
        i,
        o,
        a = Il(this),
        u = Cl(a, 0),
        s = 0;
      for (e = -1, n = arguments.length; e < n; e++) {
        if (Xl(o = -1 === e ? a : arguments[e])) {
          if (s + (i = Dl(o)) > Nl) throw ql(zl);
          for (r = 0; r < i; r++, s++) {
            r in o && Ll(u, s, o[r]);
          }
        } else {
          if (s >= Nl) throw ql(zl);
          Ll(u, s++, o);
        }
      }
      return u.length = s, u;
    }
  }), Sc("asyncIterator"), Sc("hasInstance"), Sc("isConcatSpreadable"), Sc("iterator"), Sc("match"), Sc("matchAll"), Sc("replace"), Sc("search"), Sc("species"), Sc("split"), Sc("toPrimitive"), Sc("toStringTag"), Sc("unscopables"), hu(o.JSON, "JSON", !0);
  var Ul = B.Symbol,
    Wl = Ul;
  Sc("asyncDispose"), Sc("dispose"), Sc("matcher"), Sc("metadata"), Sc("observable"), Sc("patternMatch"), Sc("replaceAll");
  var Vl = Wl;
  var Hl = Tr,
    $l = o,
    Bl = jn,
    Jl = ni,
    Kl = $,
    Ql = Qo,
    Zl = cn,
    th = V,
    eh = cs,
    rh = ae,
    nh = Rr,
    ih = Ei("slice"),
    oh = rh("species"),
    ah = $l.Array,
    uh = Math.max;
  Hl({
    target: "Array",
    proto: !0,
    forced: !ih
  }, {
    slice: function slice(t, e) {
      var r,
        n,
        i,
        o = th(this),
        a = Zl(o),
        u = Ql(t, a),
        s = Ql(void 0 === e ? a : e, a);
      if (Bl(o) && (r = o.constructor, (Jl(r) && (r === ah || Bl(r.prototype)) || Kl(r) && null === (r = r[oh])) && (r = void 0), r === ah || void 0 === r)) return nh(o, u, s);
      for (n = new (void 0 === r ? ah : r)(uh(s - u, 0)), i = 0; u < s; u++, i++) {
        u in o && eh(n, i, o[u]);
      }
      return n.length = i, n;
    }
  });
  var sh = Jr("Array").slice,
    ch = et,
    fh = sh,
    lh = Array.prototype,
    hh = function hh(t) {
      var e = t.slice;
      return t === lh || ch(lh, t) && e === lh.slice ? fh : e;
    },
    ph = hh,
    vh = zs;
  function dh(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }
    return n;
  }
  function yh(t, e) {
    var r;
    if (t) {
      if ("string" == typeof t) return dh(t, e);
      var n = ph(r = Object.prototype.toString.call(t)).call(r, 8, -1);
      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? vh(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? dh(t, e) : void 0;
    }
  }
  function gh(t, e) {
    return function (t) {
      if (xl(t)) return t;
    }(t) || function (t, e) {
      var r = null == t ? null : void 0 !== Vl && ic(t) || t["@@iterator"];
      if (null != r) {
        var n,
          i,
          o = [],
          a = !0,
          u = !1;
        try {
          for (r = r.call(t); !(a = (n = r.next()).done) && (o.push(n.value), !e || o.length !== e); a = !0) {
            ;
          }
        } catch (t) {
          u = !0, i = t;
        } finally {
          try {
            a || null == r.return || r.return();
          } finally {
            if (u) throw i;
          }
        }
        return o;
      }
    }(t, e) || yh(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  var mh = wc.f("iterator"),
    bh = mh;
  function _h(t) {
    return _h = "function" == typeof Vl && "symbol" == typeof bh ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Vl && t.constructor === Vl && t !== Vl.prototype ? "symbol" : typeof t;
    }, _h(t);
  }
  function wh(t) {
    return function (t) {
      if (xl(t)) return dh(t);
    }(t) || function (t) {
      if (void 0 !== Vl && null != ic(t) || null != t["@@iterator"]) return vh(t);
    }(t) || yh(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  var Oh = Ul,
    Eh = Jr("Array").concat,
    Th = et,
    xh = Eh,
    kh = Array.prototype,
    Sh = function Sh(t) {
      var e = t.concat;
      return t === kh || Th(kh, t) && e === kh.concat ? xh : e;
    },
    Ah = hh;
  Tr({
    target: "Reflect",
    stat: !0
  }, {
    ownKeys: fl
  });
  var jh = B.Reflect.ownKeys,
    Ph = Tl,
    Ih = Yt,
    Dh = pa;
  Tr({
    target: "Object",
    stat: !0,
    forced: a(function () {
      Dh(1);
    })
  }, {
    keys: function keys(t) {
      return Dh(Ih(t));
    }
  });
  var Lh = B.Object.keys,
    Ch = Tr,
    Rh = m,
    Mh = o.Date,
    Fh = Rh(Mh.prototype.getTime);
  Ch({
    target: "Date",
    stat: !0
  }, {
    now: function now() {
      return Fh(new Mh());
    }
  }), B.Date.now;
  var Nh = bi.forEach,
    zh = mn("forEach") ? [].forEach : function (t) {
      return Nh(this, t, arguments.length > 1 ? arguments[1] : void 0);
    };
  Tr({
    target: "Array",
    proto: !0,
    forced: [].forEach != zh
  }, {
    forEach: zh
  });
  var qh = Jr("Array").forEach,
    Yh = zn,
    Gh = Ut,
    Xh = et,
    Uh = qh,
    Wh = Array.prototype,
    Vh = {
      DOMTokenList: !0,
      NodeList: !0
    },
    Hh = function Hh(t) {
      var e = t.forEach;
      return t === Wh || Xh(Wh, t) && e === Wh.forEach || Gh(Vh, Yh(t)) ? Uh : e;
    },
    $h = Tr,
    Bh = jn,
    Jh = m([].reverse),
    Kh = [1, 2];
  $h({
    target: "Array",
    proto: !0,
    forced: String(Kh) === String(Kh.reverse())
  }, {
    reverse: function reverse() {
      return Bh(this) && (this.length = this.length), Jh(this);
    }
  });
  var Qh = Jr("Array").reverse,
    Zh = et,
    tp = Qh,
    ep = Array.prototype,
    rp = function rp(t) {
      var e = t.reverse;
      return t === ep || Zh(ep, t) && e === ep.reverse ? tp : e;
    },
    np = Tr,
    ip = o,
    op = Qo,
    ap = on,
    up = cn,
    sp = Yt,
    cp = li,
    fp = cs,
    lp = Ei("splice"),
    hp = ip.TypeError,
    pp = Math.max,
    vp = Math.min,
    dp = 9007199254740991,
    yp = "Maximum allowed length exceeded";
  np({
    target: "Array",
    proto: !0,
    forced: !lp
  }, {
    splice: function splice(t, e) {
      var r,
        n,
        i,
        o,
        a,
        u,
        s = sp(this),
        c = up(s),
        f = op(t, c),
        l = arguments.length;
      if (0 === l ? r = n = 0 : 1 === l ? (r = 0, n = c - f) : (r = l - 2, n = vp(pp(ap(e), 0), c - f)), c + r - n > dp) throw hp(yp);
      for (i = cp(s, n), o = 0; o < n; o++) {
        (a = f + o) in s && fp(i, o, s[a]);
      }
      if (i.length = n, r < n) {
        for (o = f; o < c - n; o++) {
          u = o + r, (a = o + n) in s ? s[u] = s[a] : delete s[u];
        }
        for (o = c; o > c - n + r; o--) {
          delete s[o - 1];
        }
      } else if (r > n) for (o = c - n; o > f; o--) {
        u = o + r - 1, (a = o + n - 1) in s ? s[u] = s[a] : delete s[u];
      }
      for (o = 0; o < r; o++) {
        s[o + f] = arguments[o + 2];
      }
      return s.length = c - n + r, i;
    }
  });
  var gp = Jr("Array").splice,
    mp = et,
    bp = gp,
    _p = Array.prototype,
    wp = function wp(t) {
      var e = t.splice;
      return t === _p || mp(_p, t) && e === _p.splice ? bp : e;
    },
    Op = w,
    Ep = m,
    Tp = T,
    xp = a,
    kp = pa,
    Sp = _c,
    Ap = x,
    jp = Yt,
    Pp = Y,
    Ip = Object.assign,
    Dp = Object.defineProperty,
    Lp = Ep([].concat),
    Cp = !Ip || xp(function () {
      if (Op && 1 !== Ip({
        b: 1
      }, Ip(Dp({}, "a", {
        enumerable: !0,
        get: function get() {
          Dp(this, "b", {
            value: 3,
            enumerable: !1
          });
        }
      }), {
        b: 2
      })).b) return !0;
      var t = {},
        e = {},
        r = Symbol(),
        n = "abcdefghijklmnopqrst";
      return t[r] = 7, n.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != Ip({}, t)[r] || kp(Ip({}, e)).join("") != n;
    }) ? function (t, e) {
      for (var r = jp(t), n = arguments.length, i = 1, o = Sp.f, a = Ap.f; n > i;) {
        for (var u, s = Pp(arguments[i++]), c = o ? Lp(kp(s), o(s)) : kp(s), f = c.length, l = 0; f > l;) {
          u = c[l++], Op && !Tp(a, s, u) || (r[u] = s[u]);
        }
      }
      return r;
    } : Ip,
    Rp = Cp;
  Tr({
    target: "Object",
    stat: !0,
    forced: Object.assign !== Rp
  }, {
    assign: Rp
  });
  var Mp = B.Object.assign,
    Fp = na.includes;
  Tr({
    target: "Array",
    proto: !0
  }, {
    includes: function includes(t) {
      return Fp(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), Jr("Array").includes;
  var Np = $,
    zp = R,
    qp = ae("match"),
    Yp = function Yp(t) {
      var e;
      return Np(t) && (void 0 !== (e = t[qp]) ? !!e : "RegExp" == zp(t));
    },
    Gp = o.TypeError,
    Xp = ae("match"),
    Up = Tr,
    Wp = function Wp(t) {
      if (Yp(t)) throw Gp("The method doesn't accept regular expressions");
      return t;
    },
    Vp = X,
    Hp = io,
    $p = function $p(t) {
      var e = /./;
      try {
        "/./"[t](e);
      } catch (r) {
        try {
          return e[Xp] = !1, "/./"[t](e);
        } catch (t) {}
      }
      return !1;
    },
    Bp = m("".indexOf);
  Up({
    target: "String",
    proto: !0,
    forced: !$p("includes")
  }, {
    includes: function includes(t) {
      return !!~Bp(Hp(Vp(this)), Hp(Wp(t)), arguments.length > 1 ? arguments[1] : void 0);
    }
  }), Jr("String").includes;
  var Jp = Yt,
    Kp = Va,
    Qp = Fa;
  Tr({
    target: "Object",
    stat: !0,
    forced: a(function () {
      Kp(1);
    }),
    sham: !Qp
  }, {
    getPrototypeOf: function getPrototypeOf(t) {
      return Kp(Jp(t));
    }
  });
  var Zp = B.Object.getPrototypeOf,
    tv = w,
    ev = m,
    rv = pa,
    nv = V,
    iv = ev(x.f),
    ov = ev([].push),
    av = function av(t) {
      return function (e) {
        for (var r, n = nv(e), i = rv(n), o = i.length, a = 0, u = []; o > a;) {
          r = i[a++], tv && !iv(n, r) || ov(u, t ? [r, n[r]] : n[r]);
        }
        return u;
      };
    },
    uv = {
      entries: av(!0),
      values: av(!1)
    }.values;
  Tr({
    target: "Object",
    stat: !0
  }, {
    values: function values(t) {
      return uv(t);
    }
  }), B.Object.values;
  var sv = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
    cv = X,
    fv = io,
    lv = m("".replace),
    hv = "[\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]",
    pv = RegExp("^" + hv + hv + "*"),
    vv = RegExp(hv + hv + "*$"),
    dv = function dv(t) {
      return function (e) {
        var r = fv(cv(e));
        return 1 & t && (r = lv(r, pv, "")), 2 & t && (r = lv(r, vv, "")), r;
      };
    },
    yv = {
      start: dv(1),
      end: dv(2),
      trim: dv(3)
    },
    gv = o,
    mv = a,
    bv = m,
    _v = io,
    wv = yv.trim,
    Ov = sv,
    Ev = gv.parseInt,
    Tv = gv.Symbol,
    xv = Tv && Tv.iterator,
    kv = /^[+-]?0x/i,
    Sv = bv(kv.exec),
    Av = 8 !== Ev(Ov + "08") || 22 !== Ev(Ov + "0x16") || xv && !mv(function () {
      Ev(Object(xv));
    }) ? function (t, e) {
      var r = wv(_v(t));
      return Ev(r, e >>> 0 || (Sv(kv, r) ? 16 : 10));
    } : Ev;
  Tr({
    global: !0,
    forced: parseInt != Av
  }, {
    parseInt: Av
  });
  var jv = Tr,
    Pv = na.indexOf,
    Iv = mn,
    Dv = m([].indexOf),
    Lv = !!Dv && 1 / Dv([1], 1, -0) < 0,
    Cv = Iv("indexOf");
  jv({
    target: "Array",
    proto: !0,
    forced: Lv || !Cv
  }, {
    indexOf: function indexOf(t) {
      var e = arguments.length > 1 ? arguments[1] : void 0;
      return Lv ? Dv(this, t, e) || 0 : Pv(this, t, e);
    }
  }), Jr("Array").indexOf;
  var Rv = Ho.PROPER,
    Mv = a,
    Fv = sv,
    Nv = yv.trim;
  Tr({
    target: "String",
    proto: !0,
    forced: function (t) {
      return Mv(function () {
        return !!Fv[t]() || "​᠎" !== "​᠎"[t]() || Rv && Fv[t].name !== t;
      });
    }("trim")
  }, {
    trim: function trim() {
      return Nv(this);
    }
  }), Jr("String").trim, Tr({
    target: "Object",
    stat: !0,
    sham: !w
  }, {
    create: Ma
  });
  var zv = B.Object,
    qv = function qv(t, e) {
      return zv.create(t, e);
    },
    Yv = qv,
    Gv = Tr,
    Xv = tt,
    Uv = h,
    Wv = m,
    Vv = a,
    Hv = o.Array,
    $v = Xv("JSON", "stringify"),
    Bv = Wv(/./.exec),
    Jv = Wv("".charAt),
    Kv = Wv("".charCodeAt),
    Qv = Wv("".replace),
    Zv = Wv(1..toString),
    td = /[\uD800-\uDFFF]/g,
    ed = /^[\uD800-\uDBFF]$/,
    rd = /^[\uDC00-\uDFFF]$/,
    nd = function nd(t, e, r) {
      var n = Jv(r, e - 1),
        i = Jv(r, e + 1);
      return Bv(ed, t) && !Bv(rd, i) || Bv(rd, t) && !Bv(ed, n) ? "\\u" + Zv(Kv(t, 0), 16) : t;
    },
    id = Vv(function () {
      return "\"\\udf06\\ud834\"" !== $v("\uDF06\uD834") || "\"\\udead\"" !== $v("\uDEAD");
    });
  $v && Gv({
    target: "JSON",
    stat: !0,
    forced: id
  }, {
    stringify: function stringify(t, e, r) {
      for (var n = 0, i = arguments.length, o = Hv(i); n < i; n++) {
        o[n] = arguments[n];
      }
      var a = Uv($v, null, o);
      return "string" == typeof a ? Qv(a, td, nd) : a;
    }
  });
  var od = B,
    ad = h;
  od.JSON || (od.JSON = {
    stringify: JSON.stringify
  });
  var ud = function ud(t, e, r) {
      return ad(od.JSON.stringify, null, arguments);
    },
    sd = ud,
    cd = o.TypeError,
    fd = Tr,
    ld = o,
    hd = h,
    pd = b,
    vd = Rr,
    dd = function dd(t, e) {
      if (t < e) throw cd("Not enough arguments");
      return t;
    },
    yd = /MSIE .\./.test(rt),
    gd = ld.Function,
    md = function md(t) {
      return function (e, r) {
        var n = dd(arguments.length, 1) > 2,
          i = pd(e) ? e : gd(e),
          o = n ? vd(arguments, 2) : void 0;
        return t(n ? function () {
          hd(i, this, o);
        } : i, r);
      };
    };
  fd({
    global: !0,
    bind: !0,
    forced: yd
  }, {
    setTimeout: md(ld.setTimeout),
    setInterval: md(ld.setInterval)
  });
  var bd = B.setTimeout,
    _d = Yt,
    wd = Qo,
    Od = cn,
    Ed = function Ed(t) {
      for (var e = _d(this), r = Od(e), n = arguments.length, i = wd(n > 1 ? arguments[1] : void 0, r), o = n > 2 ? arguments[2] : void 0, a = void 0 === o ? r : wd(o, r); a > i;) {
        e[i++] = t;
      }
      return e;
    };
  Tr({
    target: "Array",
    proto: !0
  }, {
    fill: Ed
  }), Jr("Array").fill;
  var Td = {
    exports: {}
  };
  !function (t) {
    function e(t) {
      if (t) return function (t) {
        for (var r in e.prototype) {
          t[r] = e.prototype[r];
        }
        return t;
      }(t);
    }
    t.exports = e, e.prototype.on = e.prototype.addEventListener = function (t, e) {
      return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
    }, e.prototype.once = function (t, e) {
      function r() {
        this.off(t, r), e.apply(this, arguments);
      }
      return r.fn = e, this.on(t, r), this;
    }, e.prototype.off = e.prototype.removeListener = e.prototype.removeAllListeners = e.prototype.removeEventListener = function (t, e) {
      if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
      var r,
        n = this._callbacks["$" + t];
      if (!n) return this;
      if (1 == arguments.length) return delete this._callbacks["$" + t], this;
      for (var i = 0; i < n.length; i++) {
        if ((r = n[i]) === e || r.fn === e) {
          n.splice(i, 1);
          break;
        }
      }
      return 0 === n.length && delete this._callbacks["$" + t], this;
    }, e.prototype.emit = function (t) {
      this._callbacks = this._callbacks || {};
      for (var e = new Array(arguments.length - 1), r = this._callbacks["$" + t], n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      if (r) {
        n = 0;
        for (var i = (r = r.slice(0)).length; n < i; ++n) {
          r[n].apply(this, e);
        }
      }
      return this;
    }, e.prototype.listeners = function (t) {
      return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
    }, e.prototype.hasListeners = function (t) {
      return !!this.listeners(t).length;
    };
  }(Td);
  var xd,
    kd = Td.exports;
  /*! Hammer.JS - v2.0.17-rc - 2019-12-16
     * http://naver.github.io/egjs
     *
     * Forked By Naver egjs
     * Copyright (c) hammerjs
     * Licensed under the MIT license */
  function Sd() {
    return Sd = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = arguments[e];
        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
        }
      }
      return t;
    }, Sd.apply(this, arguments);
  }
  function Ad(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
  }
  function jd(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  xd = "function" != typeof Object.assign ? function (t) {
    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
    for (var e = Object(t), r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      if (null != n) for (var i in n) {
        n.hasOwnProperty(i) && (e[i] = n[i]);
      }
    }
    return e;
  } : Object.assign;
  var Pd,
    Id = xd,
    Dd = ["", "webkit", "Moz", "MS", "ms", "o"],
    Ld = "undefined" == typeof document ? {
      style: {}
    } : document.createElement("div"),
    Cd = Math.round,
    Rd = Math.abs,
    Md = Date.now;
  function Fd(t, e) {
    for (var r, n, i = e[0].toUpperCase() + e.slice(1), o = 0; o < Dd.length;) {
      if ((n = (r = Dd[o]) ? r + i : e) in t) return n;
      o++;
    }
  }
  Pd = "undefined" == typeof window ? {} : window;
  var Nd = Fd(Ld.style, "touchAction"),
    zd = void 0 !== Nd;
  var qd = "compute",
    Yd = "auto",
    Gd = "manipulation",
    Xd = "none",
    Ud = "pan-x",
    Wd = "pan-y",
    Vd = function () {
      if (!zd) return !1;
      var t = {},
        e = Pd.CSS && Pd.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function (r) {
        return t[r] = !e || Pd.CSS.supports("touch-action", r);
      }), t;
    }(),
    Hd = ("ontouchstart" in Pd),
    $d = void 0 !== Fd(Pd, "PointerEvent"),
    Bd = Hd && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
    Jd = "touch",
    Kd = "mouse",
    Qd = 16,
    Zd = 24,
    ty = ["x", "y"],
    ey = ["clientX", "clientY"];
  function ry(t, e, r) {
    var n;
    if (t) if (t.forEach) t.forEach(e, r);else if (void 0 !== t.length) for (n = 0; n < t.length;) {
      e.call(r, t[n], n, t), n++;
    } else for (n in t) {
      t.hasOwnProperty(n) && e.call(r, t[n], n, t);
    }
  }
  function ny(t, e) {
    return "function" == typeof t ? t.apply(e && e[0] || void 0, e) : t;
  }
  function iy(t, e) {
    return t.indexOf(e) > -1;
  }
  var oy = function () {
    function t(t, e) {
      this.manager = t, this.set(e);
    }
    var e = t.prototype;
    return e.set = function (t) {
      t === qd && (t = this.compute()), zd && this.manager.element.style && Vd[t] && (this.manager.element.style[Nd] = t), this.actions = t.toLowerCase().trim();
    }, e.update = function () {
      this.set(this.manager.options.touchAction);
    }, e.compute = function () {
      var t = [];
      return ry(this.manager.recognizers, function (e) {
        ny(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
      }), function (t) {
        if (iy(t, Xd)) return Xd;
        var e = iy(t, Ud),
          r = iy(t, Wd);
        return e && r ? Xd : e || r ? e ? Ud : Wd : iy(t, Gd) ? Gd : Yd;
      }(t.join(" "));
    }, e.preventDefaults = function (t) {
      var e = t.srcEvent,
        r = t.offsetDirection;
      if (this.manager.session.prevented) e.preventDefault();else {
        var n = this.actions,
          i = iy(n, Xd) && !Vd.none,
          o = iy(n, Wd) && !Vd["pan-y"],
          a = iy(n, Ud) && !Vd["pan-x"];
        if (i) {
          var u = 1 === t.pointers.length,
            s = t.distance < 2,
            c = t.deltaTime < 250;
          if (u && s && c) return;
        }
        if (!a || !o) return i || o && 6 & r || a && r & Zd ? this.preventSrc(e) : void 0;
      }
    }, e.preventSrc = function (t) {
      this.manager.session.prevented = !0, t.preventDefault();
    }, t;
  }();
  function ay(t, e) {
    for (; t;) {
      if (t === e) return !0;
      t = t.parentNode;
    }
    return !1;
  }
  function uy(t) {
    var e = t.length;
    if (1 === e) return {
      x: Cd(t[0].clientX),
      y: Cd(t[0].clientY)
    };
    for (var r = 0, n = 0, i = 0; i < e;) {
      r += t[i].clientX, n += t[i].clientY, i++;
    }
    return {
      x: Cd(r / e),
      y: Cd(n / e)
    };
  }
  function sy(t) {
    for (var e = [], r = 0; r < t.pointers.length;) {
      e[r] = {
        clientX: Cd(t.pointers[r].clientX),
        clientY: Cd(t.pointers[r].clientY)
      }, r++;
    }
    return {
      timeStamp: Md(),
      pointers: e,
      center: uy(e),
      deltaX: t.deltaX,
      deltaY: t.deltaY
    };
  }
  function cy(t, e, r) {
    r || (r = ty);
    var n = e[r[0]] - t[r[0]],
      i = e[r[1]] - t[r[1]];
    return Math.sqrt(n * n + i * i);
  }
  function fy(t, e, r) {
    r || (r = ty);
    var n = e[r[0]] - t[r[0]],
      i = e[r[1]] - t[r[1]];
    return 180 * Math.atan2(i, n) / Math.PI;
  }
  function ly(t, e) {
    return t === e ? 1 : Rd(t) >= Rd(e) ? t < 0 ? 2 : 4 : e < 0 ? 8 : Qd;
  }
  function hy(t, e, r) {
    return {
      x: e / t || 0,
      y: r / t || 0
    };
  }
  function py(t, e) {
    var r = t.session,
      n = e.pointers,
      i = n.length;
    r.firstInput || (r.firstInput = sy(e)), i > 1 && !r.firstMultiple ? r.firstMultiple = sy(e) : 1 === i && (r.firstMultiple = !1);
    var o = r.firstInput,
      a = r.firstMultiple,
      u = a ? a.center : o.center,
      s = e.center = uy(n);
    e.timeStamp = Md(), e.deltaTime = e.timeStamp - o.timeStamp, e.angle = fy(u, s), e.distance = cy(u, s), function (t, e) {
      var r = e.center,
        n = t.offsetDelta || {},
        i = t.prevDelta || {},
        o = t.prevInput || {};
      1 !== e.eventType && 4 !== o.eventType || (i = t.prevDelta = {
        x: o.deltaX || 0,
        y: o.deltaY || 0
      }, n = t.offsetDelta = {
        x: r.x,
        y: r.y
      }), e.deltaX = i.x + (r.x - n.x), e.deltaY = i.y + (r.y - n.y);
    }(r, e), e.offsetDirection = ly(e.deltaX, e.deltaY);
    var c,
      f,
      l = hy(e.deltaTime, e.deltaX, e.deltaY);
    e.overallVelocityX = l.x, e.overallVelocityY = l.y, e.overallVelocity = Rd(l.x) > Rd(l.y) ? l.x : l.y, e.scale = a ? (c = a.pointers, cy((f = n)[0], f[1], ey) / cy(c[0], c[1], ey)) : 1, e.rotation = a ? function (t, e) {
      return fy(e[1], e[0], ey) + fy(t[1], t[0], ey);
    }(a.pointers, n) : 0, e.maxPointers = r.prevInput ? e.pointers.length > r.prevInput.maxPointers ? e.pointers.length : r.prevInput.maxPointers : e.pointers.length, function (t, e) {
      var r,
        n,
        i,
        o,
        a = t.lastInterval || e,
        u = e.timeStamp - a.timeStamp;
      if (8 !== e.eventType && (u > 25 || void 0 === a.velocity)) {
        var s = e.deltaX - a.deltaX,
          c = e.deltaY - a.deltaY,
          f = hy(u, s, c);
        n = f.x, i = f.y, r = Rd(f.x) > Rd(f.y) ? f.x : f.y, o = ly(s, c), t.lastInterval = e;
      } else r = a.velocity, n = a.velocityX, i = a.velocityY, o = a.direction;
      e.velocity = r, e.velocityX = n, e.velocityY = i, e.direction = o;
    }(r, e);
    var h,
      p = t.element,
      v = e.srcEvent;
    ay(h = v.composedPath ? v.composedPath()[0] : v.path ? v.path[0] : v.target, p) && (p = h), e.target = p;
  }
  function vy(t, e, r) {
    var n = r.pointers.length,
      i = r.changedPointers.length,
      o = 1 & e && n - i == 0,
      a = 12 & e && n - i == 0;
    r.isFirst = !!o, r.isFinal = !!a, o && (t.session = {}), r.eventType = e, py(t, r), t.emit("hammer.input", r), t.recognize(r), t.session.prevInput = r;
  }
  function dy(t) {
    return t.trim().split(/\s+/g);
  }
  function yy(t, e, r) {
    ry(dy(e), function (e) {
      t.addEventListener(e, r, !1);
    });
  }
  function gy(t, e, r) {
    ry(dy(e), function (e) {
      t.removeEventListener(e, r, !1);
    });
  }
  function my(t) {
    var e = t.ownerDocument || t;
    return e.defaultView || e.parentWindow || window;
  }
  var by = function () {
    function t(t, e) {
      var r = this;
      this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function (e) {
        ny(t.options.enable, [t]) && r.handler(e);
      }, this.init();
    }
    var e = t.prototype;
    return e.handler = function () {}, e.init = function () {
      this.evEl && yy(this.element, this.evEl, this.domHandler), this.evTarget && yy(this.target, this.evTarget, this.domHandler), this.evWin && yy(my(this.element), this.evWin, this.domHandler);
    }, e.destroy = function () {
      this.evEl && gy(this.element, this.evEl, this.domHandler), this.evTarget && gy(this.target, this.evTarget, this.domHandler), this.evWin && gy(my(this.element), this.evWin, this.domHandler);
    }, t;
  }();
  function _y(t, e, r) {
    if (t.indexOf && !r) return t.indexOf(e);
    for (var n = 0; n < t.length;) {
      if (r && t[n][r] == e || !r && t[n] === e) return n;
      n++;
    }
    return -1;
  }
  var wy = {
      pointerdown: 1,
      pointermove: 2,
      pointerup: 4,
      pointercancel: 8,
      pointerout: 8
    },
    Oy = {
      2: Jd,
      3: "pen",
      4: Kd,
      5: "kinect"
    },
    Ey = "pointerdown",
    Ty = "pointermove pointerup pointercancel";
  Pd.MSPointerEvent && !Pd.PointerEvent && (Ey = "MSPointerDown", Ty = "MSPointerMove MSPointerUp MSPointerCancel");
  var xy = function (t) {
    function e() {
      var r,
        n = e.prototype;
      return n.evEl = Ey, n.evWin = Ty, (r = t.apply(this, arguments) || this).store = r.manager.session.pointerEvents = [], r;
    }
    return Ad(e, t), e.prototype.handler = function (t) {
      var e = this.store,
        r = !1,
        n = t.type.toLowerCase().replace("ms", ""),
        i = wy[n],
        o = Oy[t.pointerType] || t.pointerType,
        a = o === Jd,
        u = _y(e, t.pointerId, "pointerId");
      1 & i && (0 === t.button || a) ? u < 0 && (e.push(t), u = e.length - 1) : 12 & i && (r = !0), u < 0 || (e[u] = t, this.callback(this.manager, i, {
        pointers: e,
        changedPointers: [t],
        pointerType: o,
        srcEvent: t
      }), r && e.splice(u, 1));
    }, e;
  }(by);
  function ky(t) {
    return Array.prototype.slice.call(t, 0);
  }
  function Sy(t, e, r) {
    for (var n = [], i = [], o = 0; o < t.length;) {
      var a = e ? t[o][e] : t[o];
      _y(i, a) < 0 && n.push(t[o]), i[o] = a, o++;
    }
    return r && (n = e ? n.sort(function (t, r) {
      return t[e] > r[e];
    }) : n.sort()), n;
  }
  var Ay = {
      touchstart: 1,
      touchmove: 2,
      touchend: 4,
      touchcancel: 8
    },
    jy = "touchstart touchmove touchend touchcancel",
    Py = function (t) {
      function e() {
        var r;
        return e.prototype.evTarget = jy, (r = t.apply(this, arguments) || this).targetIds = {}, r;
      }
      return Ad(e, t), e.prototype.handler = function (t) {
        var e = Ay[t.type],
          r = Iy.call(this, t, e);
        r && this.callback(this.manager, e, {
          pointers: r[0],
          changedPointers: r[1],
          pointerType: Jd,
          srcEvent: t
        });
      }, e;
    }(by);
  function Iy(t, e) {
    var r,
      n,
      i = ky(t.touches),
      o = this.targetIds;
    if (3 & e && 1 === i.length) return o[i[0].identifier] = !0, [i, i];
    var a = ky(t.changedTouches),
      u = [],
      s = this.target;
    if (n = i.filter(function (t) {
      return ay(t.target, s);
    }), 1 === e) for (r = 0; r < n.length;) {
      o[n[r].identifier] = !0, r++;
    }
    for (r = 0; r < a.length;) {
      o[a[r].identifier] && u.push(a[r]), 12 & e && delete o[a[r].identifier], r++;
    }
    return u.length ? [Sy(n.concat(u), "identifier", !0), u] : void 0;
  }
  var Dy = {
      mousedown: 1,
      mousemove: 2,
      mouseup: 4
    },
    Ly = "mousedown",
    Cy = "mousemove mouseup",
    Ry = function (t) {
      function e() {
        var r,
          n = e.prototype;
        return n.evEl = Ly, n.evWin = Cy, (r = t.apply(this, arguments) || this).pressed = !1, r;
      }
      return Ad(e, t), e.prototype.handler = function (t) {
        var e = Dy[t.type];
        1 & e && 0 === t.button && (this.pressed = !0), 2 & e && 1 !== t.which && (e = 4), this.pressed && (4 & e && (this.pressed = !1), this.callback(this.manager, e, {
          pointers: [t],
          changedPointers: [t],
          pointerType: Kd,
          srcEvent: t
        }));
      }, e;
    }(by);
  function My(t) {
    var e = t.changedPointers[0];
    if (e.identifier === this.primaryTouch) {
      var r = {
          x: e.clientX,
          y: e.clientY
        },
        n = this.lastTouches;
      this.lastTouches.push(r);
      setTimeout(function () {
        var t = n.indexOf(r);
        t > -1 && n.splice(t, 1);
      }, 2500);
    }
  }
  function Fy(t, e) {
    1 & t ? (this.primaryTouch = e.changedPointers[0].identifier, My.call(this, e)) : 12 & t && My.call(this, e);
  }
  function Ny(t) {
    for (var e = t.srcEvent.clientX, r = t.srcEvent.clientY, n = 0; n < this.lastTouches.length; n++) {
      var i = this.lastTouches[n],
        o = Math.abs(e - i.x),
        a = Math.abs(r - i.y);
      if (o <= 25 && a <= 25) return !0;
    }
    return !1;
  }
  var zy = function () {
    return function (t) {
      function e(e, r) {
        var n;
        return (n = t.call(this, e, r) || this).handler = function (t, e, r) {
          var i = r.pointerType === Jd,
            o = r.pointerType === Kd;
          if (!(o && r.sourceCapabilities && r.sourceCapabilities.firesTouchEvents)) {
            if (i) Fy.call(jd(jd(n)), e, r);else if (o && Ny.call(jd(jd(n)), r)) return;
            n.callback(t, e, r);
          }
        }, n.touch = new Py(n.manager, n.handler), n.mouse = new Ry(n.manager, n.handler), n.primaryTouch = null, n.lastTouches = [], n;
      }
      return Ad(e, t), e.prototype.destroy = function () {
        this.touch.destroy(), this.mouse.destroy();
      }, e;
    }(by);
  }();
  function qy(t, e, r) {
    return !!Array.isArray(t) && (ry(t, r[e], r), !0);
  }
  var Yy = 32,
    Gy = 1;
  function Xy(t, e) {
    var r = e.manager;
    return r ? r.get(t) : t;
  }
  function Uy(t) {
    return 16 & t ? "cancel" : 8 & t ? "end" : 4 & t ? "move" : 2 & t ? "start" : "";
  }
  var Wy = function () {
      function t(t) {
        void 0 === t && (t = {}), this.options = Sd({
          enable: !0
        }, t), this.id = Gy++, this.manager = null, this.state = 1, this.simultaneous = {}, this.requireFail = [];
      }
      var e = t.prototype;
      return e.set = function (t) {
        return Id(this.options, t), this.manager && this.manager.touchAction.update(), this;
      }, e.recognizeWith = function (t) {
        if (qy(t, "recognizeWith", this)) return this;
        var e = this.simultaneous;
        return e[(t = Xy(t, this)).id] || (e[t.id] = t, t.recognizeWith(this)), this;
      }, e.dropRecognizeWith = function (t) {
        return qy(t, "dropRecognizeWith", this) || (t = Xy(t, this), delete this.simultaneous[t.id]), this;
      }, e.requireFailure = function (t) {
        if (qy(t, "requireFailure", this)) return this;
        var e = this.requireFail;
        return -1 === _y(e, t = Xy(t, this)) && (e.push(t), t.requireFailure(this)), this;
      }, e.dropRequireFailure = function (t) {
        if (qy(t, "dropRequireFailure", this)) return this;
        t = Xy(t, this);
        var e = _y(this.requireFail, t);
        return e > -1 && this.requireFail.splice(e, 1), this;
      }, e.hasRequireFailures = function () {
        return this.requireFail.length > 0;
      }, e.canRecognizeWith = function (t) {
        return !!this.simultaneous[t.id];
      }, e.emit = function (t) {
        var e = this,
          r = this.state;
        function n(r) {
          e.manager.emit(r, t);
        }
        r < 8 && n(e.options.event + Uy(r)), n(e.options.event), t.additionalEvent && n(t.additionalEvent), r >= 8 && n(e.options.event + Uy(r));
      }, e.tryEmit = function (t) {
        if (this.canEmit()) return this.emit(t);
        this.state = Yy;
      }, e.canEmit = function () {
        for (var t = 0; t < this.requireFail.length;) {
          if (!(33 & this.requireFail[t].state)) return !1;
          t++;
        }
        return !0;
      }, e.recognize = function (t) {
        var e = Id({}, t);
        if (!ny(this.options.enable, [this, e])) return this.reset(), void (this.state = Yy);
        56 & this.state && (this.state = 1), this.state = this.process(e), 30 & this.state && this.tryEmit(e);
      }, e.process = function (t) {}, e.getTouchAction = function () {}, e.reset = function () {}, t;
    }(),
    Vy = function (t) {
      function e(e) {
        var r;
        return void 0 === e && (e = {}), (r = t.call(this, Sd({
          event: "tap",
          pointers: 1,
          taps: 1,
          interval: 300,
          time: 250,
          threshold: 9,
          posThreshold: 10
        }, e)) || this).pTime = !1, r.pCenter = !1, r._timer = null, r._input = null, r.count = 0, r;
      }
      Ad(e, t);
      var r = e.prototype;
      return r.getTouchAction = function () {
        return [Gd];
      }, r.process = function (t) {
        var e = this,
          r = this.options,
          n = t.pointers.length === r.pointers,
          i = t.distance < r.threshold,
          o = t.deltaTime < r.time;
        if (this.reset(), 1 & t.eventType && 0 === this.count) return this.failTimeout();
        if (i && o && n) {
          if (4 !== t.eventType) return this.failTimeout();
          var a = !this.pTime || t.timeStamp - this.pTime < r.interval,
            u = !this.pCenter || cy(this.pCenter, t.center) < r.posThreshold;
          if (this.pTime = t.timeStamp, this.pCenter = t.center, u && a ? this.count += 1 : this.count = 1, this._input = t, 0 === this.count % r.taps) return this.hasRequireFailures() ? (this._timer = setTimeout(function () {
            e.state = 8, e.tryEmit();
          }, r.interval), 2) : 8;
        }
        return Yy;
      }, r.failTimeout = function () {
        var t = this;
        return this._timer = setTimeout(function () {
          t.state = Yy;
        }, this.options.interval), Yy;
      }, r.reset = function () {
        clearTimeout(this._timer);
      }, r.emit = function () {
        8 === this.state && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }, e;
    }(Wy),
    Hy = function (t) {
      function e(e) {
        return void 0 === e && (e = {}), t.call(this, Sd({
          pointers: 1
        }, e)) || this;
      }
      Ad(e, t);
      var r = e.prototype;
      return r.attrTest = function (t) {
        var e = this.options.pointers;
        return 0 === e || t.pointers.length === e;
      }, r.process = function (t) {
        var e = this.state,
          r = t.eventType,
          n = 6 & e,
          i = this.attrTest(t);
        return n && (8 & r || !i) ? 16 | e : n || i ? 4 & r ? 8 | e : 2 & e ? 4 | e : 2 : Yy;
      }, e;
    }(Wy);
  function $y(t) {
    return t === Qd ? "down" : 8 === t ? "up" : 2 === t ? "left" : 4 === t ? "right" : "";
  }
  var By = function (t) {
      function e(e) {
        var r;
        return void 0 === e && (e = {}), (r = t.call(this, Sd({
          event: "pan",
          threshold: 10,
          pointers: 1,
          direction: 30
        }, e)) || this).pX = null, r.pY = null, r;
      }
      Ad(e, t);
      var r = e.prototype;
      return r.getTouchAction = function () {
        var t = this.options.direction,
          e = [];
        return 6 & t && e.push(Wd), t & Zd && e.push(Ud), e;
      }, r.directionTest = function (t) {
        var e = this.options,
          r = !0,
          n = t.distance,
          i = t.direction,
          o = t.deltaX,
          a = t.deltaY;
        return i & e.direction || (6 & e.direction ? (i = 0 === o ? 1 : o < 0 ? 2 : 4, r = o !== this.pX, n = Math.abs(t.deltaX)) : (i = 0 === a ? 1 : a < 0 ? 8 : Qd, r = a !== this.pY, n = Math.abs(t.deltaY))), t.direction = i, r && n > e.threshold && i & e.direction;
      }, r.attrTest = function (t) {
        return Hy.prototype.attrTest.call(this, t) && (2 & this.state || !(2 & this.state) && this.directionTest(t));
      }, r.emit = function (e) {
        this.pX = e.deltaX, this.pY = e.deltaY;
        var r = $y(e.direction);
        r && (e.additionalEvent = this.options.event + r), t.prototype.emit.call(this, e);
      }, e;
    }(Hy),
    Jy = function (t) {
      function e(e) {
        return void 0 === e && (e = {}), t.call(this, Sd({
          event: "swipe",
          threshold: 10,
          velocity: .3,
          direction: 30,
          pointers: 1
        }, e)) || this;
      }
      Ad(e, t);
      var r = e.prototype;
      return r.getTouchAction = function () {
        return By.prototype.getTouchAction.call(this);
      }, r.attrTest = function (e) {
        var r,
          n = this.options.direction;
        return 30 & n ? r = e.overallVelocity : 6 & n ? r = e.overallVelocityX : n & Zd && (r = e.overallVelocityY), t.prototype.attrTest.call(this, e) && n & e.offsetDirection && e.distance > this.options.threshold && e.maxPointers === this.options.pointers && Rd(r) > this.options.velocity && 4 & e.eventType;
      }, r.emit = function (t) {
        var e = $y(t.offsetDirection);
        e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t);
      }, e;
    }(Hy),
    Ky = function (t) {
      function e(e) {
        return void 0 === e && (e = {}), t.call(this, Sd({
          event: "pinch",
          threshold: 0,
          pointers: 2
        }, e)) || this;
      }
      Ad(e, t);
      var r = e.prototype;
      return r.getTouchAction = function () {
        return [Xd];
      }, r.attrTest = function (e) {
        return t.prototype.attrTest.call(this, e) && (Math.abs(e.scale - 1) > this.options.threshold || 2 & this.state);
      }, r.emit = function (e) {
        if (1 !== e.scale) {
          var r = e.scale < 1 ? "in" : "out";
          e.additionalEvent = this.options.event + r;
        }
        t.prototype.emit.call(this, e);
      }, e;
    }(Hy),
    Qy = function (t) {
      function e(e) {
        return void 0 === e && (e = {}), t.call(this, Sd({
          event: "rotate",
          threshold: 0,
          pointers: 2
        }, e)) || this;
      }
      Ad(e, t);
      var r = e.prototype;
      return r.getTouchAction = function () {
        return [Xd];
      }, r.attrTest = function (e) {
        return t.prototype.attrTest.call(this, e) && (Math.abs(e.rotation) > this.options.threshold || 2 & this.state);
      }, e;
    }(Hy),
    Zy = function (t) {
      function e(e) {
        var r;
        return void 0 === e && (e = {}), (r = t.call(this, Sd({
          event: "press",
          pointers: 1,
          time: 251,
          threshold: 9
        }, e)) || this)._timer = null, r._input = null, r;
      }
      Ad(e, t);
      var r = e.prototype;
      return r.getTouchAction = function () {
        return [Yd];
      }, r.process = function (t) {
        var e = this,
          r = this.options,
          n = t.pointers.length === r.pointers,
          i = t.distance < r.threshold,
          o = t.deltaTime > r.time;
        if (this._input = t, !i || !n || 12 & t.eventType && !o) this.reset();else if (1 & t.eventType) this.reset(), this._timer = setTimeout(function () {
          e.state = 8, e.tryEmit();
        }, r.time);else if (4 & t.eventType) return 8;
        return Yy;
      }, r.reset = function () {
        clearTimeout(this._timer);
      }, r.emit = function (t) {
        8 === this.state && (t && 4 & t.eventType ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = Md(), this.manager.emit(this.options.event, this._input)));
      }, e;
    }(Wy),
    tg = {
      domEvents: !1,
      touchAction: qd,
      enable: !0,
      inputTarget: null,
      inputClass: null,
      cssProps: {
        userSelect: "none",
        touchSelect: "none",
        touchCallout: "none",
        contentZooming: "none",
        userDrag: "none",
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    },
    eg = [[Qy, {
      enable: !1
    }], [Ky, {
      enable: !1
    }, ["rotate"]], [Jy, {
      direction: 6
    }], [By, {
      direction: 6
    }, ["swipe"]], [Vy], [Vy, {
      event: "doubletap",
      taps: 2
    }, ["tap"]], [Zy]];
  function rg(t, e) {
    var r,
      n = t.element;
    n.style && (ry(t.options.cssProps, function (i, o) {
      r = Fd(n.style, o), e ? (t.oldCssProps[r] = n.style[r], n.style[r] = i) : n.style[r] = t.oldCssProps[r] || "";
    }), e || (t.oldCssProps = {}));
  }
  var ng = function () {
      function t(t, e) {
        var r,
          n = this;
        this.options = Id({}, tg, e || {}), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = t, this.input = new ((r = this).options.inputClass || ($d ? xy : Bd ? Py : Hd ? zy : Ry))(r, vy), this.touchAction = new oy(this, this.options.touchAction), rg(this, !0), ry(this.options.recognizers, function (t) {
          var e = n.add(new t[0](t[1]));
          t[2] && e.recognizeWith(t[2]), t[3] && e.requireFailure(t[3]);
        }, this);
      }
      var e = t.prototype;
      return e.set = function (t) {
        return Id(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this;
      }, e.stop = function (t) {
        this.session.stopped = t ? 2 : 1;
      }, e.recognize = function (t) {
        var e = this.session;
        if (!e.stopped) {
          var r;
          this.touchAction.preventDefaults(t);
          var n = this.recognizers,
            i = e.curRecognizer;
          (!i || i && 8 & i.state) && (e.curRecognizer = null, i = null);
          for (var o = 0; o < n.length;) {
            r = n[o], 2 === e.stopped || i && r !== i && !r.canRecognizeWith(i) ? r.reset() : r.recognize(t), !i && 14 & r.state && (e.curRecognizer = r, i = r), o++;
          }
        }
      }, e.get = function (t) {
        if (t instanceof Wy) return t;
        for (var e = this.recognizers, r = 0; r < e.length; r++) {
          if (e[r].options.event === t) return e[r];
        }
        return null;
      }, e.add = function (t) {
        if (qy(t, "add", this)) return this;
        var e = this.get(t.options.event);
        return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t;
      }, e.remove = function (t) {
        if (qy(t, "remove", this)) return this;
        var e = this.get(t);
        if (t) {
          var r = this.recognizers,
            n = _y(r, e);
          -1 !== n && (r.splice(n, 1), this.touchAction.update());
        }
        return this;
      }, e.on = function (t, e) {
        if (void 0 === t || void 0 === e) return this;
        var r = this.handlers;
        return ry(dy(t), function (t) {
          r[t] = r[t] || [], r[t].push(e);
        }), this;
      }, e.off = function (t, e) {
        if (void 0 === t) return this;
        var r = this.handlers;
        return ry(dy(t), function (t) {
          e ? r[t] && r[t].splice(_y(r[t], e), 1) : delete r[t];
        }), this;
      }, e.emit = function (t, e) {
        this.options.domEvents && function (t, e) {
          var r = document.createEvent("Event");
          r.initEvent(t, !0, !0), r.gesture = e, e.target.dispatchEvent(r);
        }(t, e);
        var r = this.handlers[t] && this.handlers[t].slice();
        if (r && r.length) {
          e.type = t, e.preventDefault = function () {
            e.srcEvent.preventDefault();
          };
          for (var n = 0; n < r.length;) {
            r[n](e), n++;
          }
        }
      }, e.destroy = function () {
        this.element && rg(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }, t;
    }(),
    ig = {
      touchstart: 1,
      touchmove: 2,
      touchend: 4,
      touchcancel: 8
    },
    og = "touchstart",
    ag = "touchstart touchmove touchend touchcancel",
    ug = function (t) {
      function e() {
        var r,
          n = e.prototype;
        return n.evTarget = og, n.evWin = ag, (r = t.apply(this, arguments) || this).started = !1, r;
      }
      return Ad(e, t), e.prototype.handler = function (t) {
        var e = ig[t.type];
        if (1 === e && (this.started = !0), this.started) {
          var r = sg.call(this, t, e);
          12 & e && r[0].length - r[1].length == 0 && (this.started = !1), this.callback(this.manager, e, {
            pointers: r[0],
            changedPointers: r[1],
            pointerType: Jd,
            srcEvent: t
          });
        }
      }, e;
    }(by);
  function sg(t, e) {
    var r = ky(t.touches),
      n = ky(t.changedTouches);
    return 12 & e && (r = Sy(r.concat(n), "identifier", !0)), [r, n];
  }
  function cg(t, e, r) {
    var n = "DEPRECATED METHOD: " + e + "\n" + r + " AT \n";
    return function () {
      var e = new Error("get-stack-trace"),
        r = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
        i = window.console && (window.console.warn || window.console.log);
      return i && i.call(window.console, n, r), t.apply(this, arguments);
    };
  }
  var fg = cg(function (t, e, r) {
      for (var n = Object.keys(e), i = 0; i < n.length;) {
        (!r || r && void 0 === t[n[i]]) && (t[n[i]] = e[n[i]]), i++;
      }
      return t;
    }, "extend", "Use `assign`."),
    lg = cg(function (t, e) {
      return fg(t, e, !0);
    }, "merge", "Use `assign`.");
  function hg(t, e, r) {
    var n,
      i = e.prototype;
    (n = t.prototype = Object.create(i)).constructor = t, n._super = i, r && Id(n, r);
  }
  function pg(t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }
  var vg = function () {
    var t = function t(_t2, e) {
      return void 0 === e && (e = {}), new ng(_t2, Sd({
        recognizers: eg.concat()
      }, e));
    };
    return t.VERSION = "2.0.17-rc", t.DIRECTION_ALL = 30, t.DIRECTION_DOWN = Qd, t.DIRECTION_LEFT = 2, t.DIRECTION_RIGHT = 4, t.DIRECTION_UP = 8, t.DIRECTION_HORIZONTAL = 6, t.DIRECTION_VERTICAL = Zd, t.DIRECTION_NONE = 1, t.DIRECTION_DOWN = Qd, t.INPUT_START = 1, t.INPUT_MOVE = 2, t.INPUT_END = 4, t.INPUT_CANCEL = 8, t.STATE_POSSIBLE = 1, t.STATE_BEGAN = 2, t.STATE_CHANGED = 4, t.STATE_ENDED = 8, t.STATE_RECOGNIZED = 8, t.STATE_CANCELLED = 16, t.STATE_FAILED = Yy, t.Manager = ng, t.Input = by, t.TouchAction = oy, t.TouchInput = Py, t.MouseInput = Ry, t.PointerEventInput = xy, t.TouchMouseInput = zy, t.SingleTouchInput = ug, t.Recognizer = Wy, t.AttrRecognizer = Hy, t.Tap = Vy, t.Pan = By, t.Swipe = Jy, t.Pinch = Ky, t.Rotate = Qy, t.Press = Zy, t.on = yy, t.off = gy, t.each = ry, t.merge = lg, t.extend = fg, t.bindFn = pg, t.assign = Id, t.inherit = hg, t.bindFn = pg, t.prefixed = Fd, t.toArray = ky, t.inArray = _y, t.uniqueArray = Sy, t.splitStr = dy, t.boolOrFn = ny, t.hasParent = ay, t.addEventListeners = yy, t.removeEventListeners = gy, t.defaults = Id({}, tg, {
      preset: eg
    }), t;
  }();
  function dg(t, e) {
    var r = void 0 !== Oh && ic(t) || t["@@iterator"];
    if (!r) {
      if (Ph(t) || (r = function (t, e) {
        var r;
        if (!t) return;
        if ("string" == typeof t) return yg(t, e);
        var n = Ah(r = Object.prototype.toString.call(t)).call(r, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return qs(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return yg(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        r && (t = r);
        var _n2 = 0,
          i = function i() {};
        return {
          s: i,
          n: function n() {
            return _n2 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n2++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: i
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      a = !0,
      u = !1;
    return {
      s: function s() {
        r = r.call(t);
      },
      n: function n() {
        var t = r.next();
        return a = t.done, t;
      },
      e: function e(t) {
        u = !0, o = t;
      },
      f: function f() {
        try {
          a || null == r.return || r.return();
        } finally {
          if (u) throw o;
        }
      }
    };
  }
  function yg(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }
    return n;
  }
  var gg = Oh("DELETE");
  function mg() {
    var t = bg.apply(void 0, arguments);
    return wg(t), t;
  }
  function bg() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
      e[r] = arguments[r];
    }
    if (e.length < 2) return e[0];
    var n;
    if (e.length > 2) return bg.apply(void 0, Sh(n = [mg(e[0], e[1])]).call(n, wh(Ah(e).call(e, 2))));
    var i,
      o = e[0],
      a = e[1],
      u = dg(jh(a));
    try {
      for (u.s(); !(i = u.n()).done;) {
        var s = i.value;
        Object.prototype.propertyIsEnumerable.call(a, s) && (a[s] === gg ? delete o[s] : null === o[s] || null === a[s] || "object" !== _h(o[s]) || "object" !== _h(a[s]) || Ph(o[s]) || Ph(a[s]) ? o[s] = _g(a[s]) : o[s] = bg(o[s], a[s]));
      }
    } catch (t) {
      u.e(t);
    } finally {
      u.f();
    }
    return o;
  }
  function _g(t) {
    return Ph(t) ? Ri(t).call(t, function (t) {
      return _g(t);
    }) : "object" === _h(t) && null !== t ? bg({}, t) : t;
  }
  function wg(t) {
    for (var e = 0, r = Lh(t); e < r.length; e++) {
      var n = r[e];
      t[n] === gg ? delete t[n] : "object" === _h(t[n]) && null !== t[n] && wg(t[n]);
    }
  }
  var Og = "undefined" != typeof window ? window.Hammer || vg : function () {
    return function () {
      var t = function t() {};
      return {
        on: t,
        off: t,
        destroy: t,
        emit: t,
        get: function get() {
          return {
            set: t
          };
        }
      };
    }();
  };
  function Eg(t) {
    var e,
      r = this;
    this._cleanupQueue = [], this.active = !1, this._dom = {
      container: t,
      overlay: document.createElement("div")
    }, this._dom.overlay.classList.add("vis-overlay"), this._dom.container.appendChild(this._dom.overlay), this._cleanupQueue.push(function () {
      r._dom.overlay.parentNode.removeChild(r._dom.overlay);
    });
    var n = Og(this._dom.overlay);
    n.on("tap", en(e = this._onTapOverlay).call(e, this)), this._cleanupQueue.push(function () {
      n.destroy();
    });
    var i = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];
    Hh(i).call(i, function (t) {
      n.on(t, function (t) {
        t.srcEvent.stopPropagation();
      });
    }), document && document.body && (this._onClick = function (e) {
      (function (t, e) {
        for (; t;) {
          if (t === e) return !0;
          t = t.parentNode;
        }
        return !1;
      })(e.target, t) || r.deactivate();
    }, document.body.addEventListener("click", this._onClick), this._cleanupQueue.push(function () {
      document.body.removeEventListener("click", r._onClick);
    })), this._escListener = function (t) {
      ("key" in t ? "Escape" === t.key : 27 === t.keyCode) && r.deactivate();
    };
  }
  kd(Eg.prototype), Eg.current = null, Eg.prototype.destroy = function () {
    var t, e;
    this.deactivate();
    var r,
      n = dg(rp(t = wp(e = this._cleanupQueue).call(e, 0)).call(t));
    try {
      for (n.s(); !(r = n.n()).done;) {
        (0, r.value)();
      }
    } catch (t) {
      n.e(t);
    } finally {
      n.f();
    }
  }, Eg.prototype.activate = function () {
    Eg.current && Eg.current.deactivate(), Eg.current = this, this.active = !0, this._dom.overlay.style.display = "none", this._dom.container.classList.add("vis-active"), this.emit("change"), this.emit("activate"), document.body.addEventListener("keydown", this._escListener);
  }, Eg.prototype.deactivate = function () {
    this.active = !1, this._dom.overlay.style.display = "block", this._dom.container.classList.remove("vis-active"), document.body.removeEventListener("keydown", this._escListener), this.emit("change"), this.emit("deactivate");
  }, Eg.prototype._onTapOverlay = function (t) {
    this.activate(), t.srcEvent.stopPropagation();
  };
  var Tg = ni,
    xg = wt,
    kg = o.TypeError,
    Sg = Tr,
    Ag = h,
    jg = Hr,
    Pg = function Pg(t) {
      if (Tg(t)) return t;
      throw kg(xg(t) + " is not a constructor");
    },
    Ig = Qe,
    Dg = $,
    Lg = Ma,
    Cg = a,
    Rg = tt("Reflect", "construct"),
    Mg = Object.prototype,
    Fg = [].push,
    Ng = Cg(function () {
      function t() {}
      return !(Rg(function () {}, [], t) instanceof t);
    }),
    zg = !Cg(function () {
      Rg(function () {});
    }),
    qg = Ng || zg;
  Sg({
    target: "Reflect",
    stat: !0,
    forced: qg,
    sham: qg
  }, {
    construct: function construct(t, e) {
      Pg(t), Ig(e);
      var r = arguments.length < 3 ? t : Pg(arguments[2]);
      if (zg && !Ng) return Rg(t, e, r);
      if (t == r) {
        switch (e.length) {
          case 0:
            return new t();
          case 1:
            return new t(e[0]);
          case 2:
            return new t(e[0], e[1]);
          case 3:
            return new t(e[0], e[1], e[2]);
          case 4:
            return new t(e[0], e[1], e[2], e[3]);
        }
        var n = [null];
        return Ag(Fg, n, e), new (Ag(jg, t, n))();
      }
      var i = r.prototype,
        o = Lg(Dg(i) ? i : Mg),
        a = Ag(t, o, e);
      return Dg(a) ? a : o;
    }
  });
  var Yg = B.Reflect.construct;
  function Gg(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  var Xg = qv;
  Tr({
    target: "Object",
    stat: !0
  }, {
    setPrototypeOf: Su
  });
  var Ug = B.Object.setPrototypeOf;
  function Wg(t, e) {
    return Wg = Ug || function (t, e) {
      return t.__proto__ = e, t;
    }, Wg(t, e);
  }
  function Vg(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Xg(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Ir(t, "prototype", {
      writable: !1
    }), e && Wg(t, e);
  }
  function Hg(t, e) {
    if (e && ("object" === _h(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return Gg(t);
  }
  var $g = Zp;
  function Bg(t) {
    return Bg = Ug ? $g : function (t) {
      return t.__proto__ || $g(t);
    }, Bg(t);
  }
  var Jg = {
    exports: {}
  };
  !function (t) {
    var e = function (t) {
      var e,
        r = Object.prototype,
        n = r.hasOwnProperty,
        i = "function" == typeof Symbol ? Symbol : {},
        o = i.iterator || "@@iterator",
        a = i.asyncIterator || "@@asyncIterator",
        u = i.toStringTag || "@@toStringTag";
      function s(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }
      try {
        s({}, "");
      } catch (t) {
        s = function s(t, e, r) {
          return t[e] = r;
        };
      }
      function c(t, e, r, n) {
        var i = e && e.prototype instanceof y ? e : y,
          o = Object.create(i.prototype),
          a = new A(n || []);
        return o._invoke = function (t, e, r) {
          var n = l;
          return function (i, o) {
            if (n === p) throw new Error("Generator is already running");
            if (n === v) {
              if ("throw" === i) throw o;
              return P();
            }
            for (r.method = i, r.arg = o;;) {
              var a = r.delegate;
              if (a) {
                var u = x(a, r);
                if (u) {
                  if (u === d) continue;
                  return u;
                }
              }
              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === l) throw n = v, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = p;
              var s = f(t, e, r);
              if ("normal" === s.type) {
                if (n = r.done ? v : h, s.arg === d) continue;
                return {
                  value: s.arg,
                  done: r.done
                };
              }
              "throw" === s.type && (n = v, r.method = "throw", r.arg = s.arg);
            }
          };
        }(t, r, a), o;
      }
      function f(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }
      t.wrap = c;
      var l = "suspendedStart",
        h = "suspendedYield",
        p = "executing",
        v = "completed",
        d = {};
      function y() {}
      function g() {}
      function m() {}
      var b = {};
      s(b, o, function () {
        return this;
      });
      var _ = Object.getPrototypeOf,
        w = _ && _(_(j([])));
      w && w !== r && n.call(w, o) && (b = w);
      var O = m.prototype = y.prototype = Object.create(b);
      function E(t) {
        ["next", "throw", "return"].forEach(function (e) {
          s(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }
      function T(t, e) {
        function r(i, o, a, u) {
          var s = f(t[i], t, o);
          if ("throw" !== s.type) {
            var c = s.arg,
              l = c.value;
            return l && "object" == typeof l && n.call(l, "__await") ? e.resolve(l.__await).then(function (t) {
              r("next", t, a, u);
            }, function (t) {
              r("throw", t, a, u);
            }) : e.resolve(l).then(function (t) {
              c.value = t, a(c);
            }, function (t) {
              return r("throw", t, a, u);
            });
          }
          u(s.arg);
        }
        var i;
        this._invoke = function (t, n) {
          function o() {
            return new e(function (e, i) {
              r(t, n, e, i);
            });
          }
          return i = i ? i.then(o, o) : o();
        };
      }
      function x(t, r) {
        var n = t.iterator[r.method];
        if (n === e) {
          if (r.delegate = null, "throw" === r.method) {
            if (t.iterator.return && (r.method = "return", r.arg = e, x(t, r), "throw" === r.method)) return d;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return d;
        }
        var i = f(n, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, d;
        var o = i.arg;
        return o ? o.done ? (r[t.resultName] = o.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, d) : o : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, d);
      }
      function k(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }
      function S(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }
      function A(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(k, this), this.reset(!0);
      }
      function j(t) {
        if (t) {
          var r = t[o];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;
          if (!isNaN(t.length)) {
            var i = -1,
              a = function r() {
                for (; ++i < t.length;) {
                  if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
                }
                return r.value = e, r.done = !0, r;
              };
            return a.next = a;
          }
        }
        return {
          next: P
        };
      }
      function P() {
        return {
          value: e,
          done: !0
        };
      }
      return g.prototype = m, s(O, "constructor", m), s(m, "constructor", g), g.displayName = s(m, u, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === g || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, m) : (t.__proto__ = m, s(t, u, "GeneratorFunction")), t.prototype = Object.create(O), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, E(T.prototype), s(T.prototype, a, function () {
        return this;
      }), t.AsyncIterator = T, t.async = function (e, r, n, i, o) {
        void 0 === o && (o = Promise);
        var a = new T(c(e, r, n, i), o);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, E(O), s(O, u, "Generator"), s(O, o, function () {
        return this;
      }), s(O, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (t) {
        var e = [];
        for (var r in t) {
          e.push(r);
        }
        return e.reverse(), function r() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return r.value = n, r.done = !1, r;
          }
          return r.done = !0, r;
        };
      }, t.values = j, A.prototype = {
        constructor: A,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(S), !t) for (var r in this) {
            "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var r = this;
          function i(n, i) {
            return u.type = "throw", u.arg = t, r.next = n, i && (r.method = "next", r.arg = e), !!i;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var a = this.tryEntries[o],
              u = a.completion;
            if ("root" === a.tryLoc) return i("end");
            if (a.tryLoc <= this.prev) {
              var s = n.call(a, "catchLoc"),
                c = n.call(a, "finallyLoc");
              if (s && c) {
                if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return i(a.finallyLoc);
              } else if (s) {
                if (this.prev < a.catchLoc) return i(a.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return i(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var i = this.tryEntries[r];
            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }
          o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), d;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), S(r), d;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ("throw" === n.type) {
                var i = n.arg;
                S(r);
              }
              return i;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, r, n) {
          return this.delegate = {
            iterator: j(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), d;
        }
      }, t;
    }(t.exports);
    try {
      regeneratorRuntime = e;
    } catch (t) {
      "object" == typeof globalThis ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
    }
  }(Jg);
  var Kg = Jg.exports,
    Qg = {
      exports: {}
    },
    Zg = a(function () {
      if ("function" == typeof ArrayBuffer) {
        var t = new ArrayBuffer(8);
        Object.isExtensible(t) && Object.defineProperty(t, "a", {
          value: 8
        });
      }
    }),
    tm = a,
    em = $,
    rm = R,
    nm = Zg,
    im = Object.isExtensible,
    om = tm(function () {
      im(1);
    }) || nm ? function (t) {
      return !!em(t) && (!nm || "ArrayBuffer" != rm(t)) && (!im || im(t));
    } : im,
    am = !a(function () {
      return Object.isExtensible(Object.preventExtensions({}));
    }),
    um = Tr,
    sm = m,
    cm = Eo,
    fm = $,
    lm = Ut,
    hm = Ve.f,
    pm = oc,
    vm = sc,
    dm = om,
    ym = am,
    gm = !1,
    mm = Bt("meta"),
    bm = 0,
    _m = function _m(t) {
      hm(t, mm, {
        value: {
          objectID: "O" + bm++,
          weakData: {}
        }
      });
    },
    wm = Qg.exports = {
      enable: function enable() {
        wm.enable = function () {}, gm = !0;
        var t = pm.f,
          e = sm([].splice),
          r = {};
        r[mm] = 1, t(r).length && (pm.f = function (r) {
          for (var n = t(r), i = 0, o = n.length; i < o; i++) {
            if (n[i] === mm) {
              e(n, i, 1);
              break;
            }
          }
          return n;
        }, um({
          target: "Object",
          stat: !0,
          forced: !0
        }, {
          getOwnPropertyNames: vm.f
        }));
      },
      fastKey: function fastKey(t, e) {
        if (!fm(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
        if (!lm(t, mm)) {
          if (!dm(t)) return "F";
          if (!e) return "E";
          _m(t);
        }
        return t[mm].objectID;
      },
      getWeakData: function getWeakData(t, e) {
        if (!lm(t, mm)) {
          if (!dm(t)) return !0;
          if (!e) return !1;
          _m(t);
        }
        return t[mm].weakData;
      },
      onFreeze: function onFreeze(t) {
        return ym && gm && dm(t) && !lm(t, mm) && _m(t), t;
      }
    };
  cm[mm] = !0;
  var Om = We,
    Em = T,
    Tm = Qe,
    xm = wt,
    km = os,
    Sm = cn,
    Am = et,
    jm = ws,
    Pm = vs,
    Im = Zu,
    Dm = o.TypeError,
    Lm = function Lm(t, e) {
      this.stopped = t, this.result = e;
    },
    Cm = Lm.prototype,
    Rm = function Rm(t, e, r) {
      var n,
        i,
        o,
        a,
        u,
        s,
        c,
        f = r && r.that,
        l = !(!r || !r.AS_ENTRIES),
        h = !(!r || !r.IS_ITERATOR),
        p = !(!r || !r.INTERRUPTED),
        v = Om(e, f),
        d = function d(t) {
          return n && Im(n, "normal", t), new Lm(!0, t);
        },
        y = function y(t) {
          return l ? (Tm(t), p ? v(t[0], t[1], d) : v(t[0], t[1])) : p ? v(t, d) : v(t);
        };
      if (h) n = t;else {
        if (!(i = Pm(t))) throw Dm(xm(t) + " is not iterable");
        if (km(i)) {
          for (o = 0, a = Sm(t); a > o; o++) {
            if ((u = y(t[o])) && Am(Cm, u)) return u;
          }
          return new Lm(!1);
        }
        n = jm(t, i);
      }
      for (s = n.next; !(c = Em(s, n)).done;) {
        try {
          u = y(c.value);
        } catch (t) {
          Im(n, "throw", t);
        }
        if ("object" == typeof u && u && Am(Cm, u)) return u;
      }
      return new Lm(!1);
    },
    Mm = et,
    Fm = o.TypeError,
    Nm = function Nm(t, e) {
      if (Mm(e, t)) return t;
      throw Fm("Incorrect invocation");
    },
    zm = Tr,
    qm = o,
    Ym = Qg.exports,
    Gm = a,
    Xm = hr,
    Um = Rm,
    Wm = Nm,
    Vm = b,
    Hm = $,
    $m = hu,
    Bm = Ve.f,
    Jm = bi.forEach,
    Km = w,
    Qm = Yo.set,
    Zm = Yo.getterFor,
    tb = function tb(t, e, r) {
      var n,
        i = -1 !== t.indexOf("Map"),
        o = -1 !== t.indexOf("Weak"),
        a = i ? "set" : "add",
        u = qm[t],
        s = u && u.prototype,
        c = {};
      if (Km && Vm(u) && (o || s.forEach && !Gm(function () {
        new u().entries().next();
      }))) {
        var f = (n = e(function (e, r) {
            Qm(Wm(e, f), {
              type: t,
              collection: new u()
            }), null != r && Um(r, e[a], {
              that: e,
              AS_ENTRIES: i
            });
          })).prototype,
          l = Zm(t);
        Jm(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function (t) {
          var e = "add" == t || "set" == t;
          !(t in s) || o && "clear" == t || Xm(f, t, function (r, n) {
            var i = l(this).collection;
            if (!e && o && !Hm(r)) return "get" == t && void 0;
            var a = i[t](0 === r ? 0 : r, n);
            return e ? this : a;
          });
        }), o || Bm(f, "size", {
          configurable: !0,
          get: function get() {
            return l(this).collection.size;
          }
        });
      } else n = r.getConstructor(e, t, i, a), Ym.enable();
      return $m(n, t, !1, !0), c[t] = n, zm({
        global: !0,
        forced: !0
      }, c), o || r.setStrong(n, t, i), n;
    },
    eb = $a,
    rb = tt,
    nb = Ve,
    ib = w,
    ob = ae("species"),
    ab = Ve.f,
    ub = Ma,
    sb = function sb(t, e, r) {
      for (var n in e) {
        r && r.unsafe && t[n] ? t[n] = e[n] : eb(t, n, e[n], r);
      }
      return t;
    },
    cb = We,
    fb = Nm,
    lb = Rm,
    hb = Gu,
    pb = function pb(t) {
      var e = rb(t),
        r = nb.f;
      ib && e && !e[ob] && r(e, ob, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    },
    vb = w,
    db = Qg.exports.fastKey,
    yb = Yo.set,
    gb = Yo.getterFor,
    mb = {
      getConstructor: function getConstructor(t, e, r, n) {
        var i = t(function (t, i) {
            fb(t, o), yb(t, {
              type: e,
              index: ub(null),
              first: void 0,
              last: void 0,
              size: 0
            }), vb || (t.size = 0), null != i && lb(i, t[n], {
              that: t,
              AS_ENTRIES: r
            });
          }),
          o = i.prototype,
          a = gb(e),
          u = function u(t, e, r) {
            var n,
              i,
              o = a(t),
              u = s(t, e);
            return u ? u.value = r : (o.last = u = {
              index: i = db(e, !0),
              key: e,
              value: r,
              previous: n = o.last,
              next: void 0,
              removed: !1
            }, o.first || (o.first = u), n && (n.next = u), vb ? o.size++ : t.size++, "F" !== i && (o.index[i] = u)), t;
          },
          s = function s(t, e) {
            var r,
              n = a(t),
              i = db(e);
            if ("F" !== i) return n.index[i];
            for (r = n.first; r; r = r.next) {
              if (r.key == e) return r;
            }
          };
        return sb(o, {
          clear: function clear() {
            for (var t = a(this), e = t.index, r = t.first; r;) {
              r.removed = !0, r.previous && (r.previous = r.previous.next = void 0), delete e[r.index], r = r.next;
            }
            t.first = t.last = void 0, vb ? t.size = 0 : this.size = 0;
          },
          delete: function _delete(t) {
            var e = this,
              r = a(e),
              n = s(e, t);
            if (n) {
              var i = n.next,
                o = n.previous;
              delete r.index[n.index], n.removed = !0, o && (o.next = i), i && (i.previous = o), r.first == n && (r.first = i), r.last == n && (r.last = o), vb ? r.size-- : e.size--;
            }
            return !!n;
          },
          forEach: function forEach(t) {
            for (var e, r = a(this), n = cb(t, arguments.length > 1 ? arguments[1] : void 0); e = e ? e.next : r.first;) {
              for (n(e.value, e.key, this); e && e.removed;) {
                e = e.previous;
              }
            }
          },
          has: function has(t) {
            return !!s(this, t);
          }
        }), sb(o, r ? {
          get: function get(t) {
            var e = s(this, t);
            return e && e.value;
          },
          set: function set(t, e) {
            return u(this, 0 === t ? 0 : t, e);
          }
        } : {
          add: function add(t) {
            return u(this, t = 0 === t ? 0 : t, t);
          }
        }), vb && ab(o, "size", {
          get: function get() {
            return a(this).size;
          }
        }), i;
      },
      setStrong: function setStrong(t, e, r) {
        var n = e + " Iterator",
          i = gb(e),
          o = gb(n);
        hb(t, e, function (t, e) {
          yb(this, {
            type: n,
            target: t,
            state: i(t),
            kind: e,
            last: void 0
          });
        }, function () {
          for (var t = o(this), e = t.kind, r = t.last; r && r.removed;) {
            r = r.previous;
          }
          return t.target && (t.last = r = r ? r.next : t.state.first) ? "keys" == e ? {
            value: r.key,
            done: !1
          } : "values" == e ? {
            value: r.value,
            done: !1
          } : {
            value: [r.key, r.value],
            done: !1
          } : (t.target = void 0, {
            value: void 0,
            done: !0
          });
        }, r ? "entries" : "values", !r, !0), pb(e);
      }
    };
  tb("Map", function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0);
    };
  }, mb);
  var bb = B.Map,
    _b = bi.some;
  Tr({
    target: "Array",
    proto: !0,
    forced: !mn("some")
  }, {
    some: function some(t) {
      return _b(this, t, arguments.length > 1 ? arguments[1] : void 0);
    }
  });
  var wb = Jr("Array").some,
    Ob = et,
    Eb = wb,
    Tb = Array.prototype,
    xb = function xb(t) {
      var e = t.some;
      return t === Tb || Ob(Tb, t) && e === Tb.some ? Eb : e;
    },
    kb = Jr("Array").keys,
    Sb = zn,
    Ab = Ut,
    jb = et,
    Pb = kb,
    Ib = Array.prototype,
    Db = {
      DOMTokenList: !0,
      NodeList: !0
    },
    Lb = function Lb(t) {
      var e = t.keys;
      return t === Ib || jb(Ib, t) && e === Ib.keys || Ab(Db, Sb(t)) ? Pb : e;
    },
    Cb = vc,
    Rb = Math.floor,
    Mb = function Mb(t, e) {
      var r = t.length,
        n = Rb(r / 2);
      return r < 8 ? Fb(t, e) : Nb(t, Mb(Cb(t, 0, n), e), Mb(Cb(t, n), e), e);
    },
    Fb = function Fb(t, e) {
      for (var r, n, i = t.length, o = 1; o < i;) {
        for (n = o, r = t[o]; n && e(t[n - 1], r) > 0;) {
          t[n] = t[--n];
        }
        n !== o++ && (t[n] = r);
      }
      return t;
    },
    Nb = function Nb(t, e, r, n) {
      for (var i = e.length, o = r.length, a = 0, u = 0; a < i || u < o;) {
        t[a + u] = a < i && u < o ? n(e[a], r[u]) <= 0 ? e[a++] : r[u++] : a < i ? e[a++] : r[u++];
      }
      return t;
    },
    zb = Mb,
    qb = rt.match(/firefox\/(\d+)/i),
    Yb = !!qb && +qb[1],
    Gb = /MSIE|Trident/.test(rt),
    Xb = rt.match(/AppleWebKit\/(\d+)\./),
    Ub = !!Xb && +Xb[1],
    Wb = Tr,
    Vb = m,
    Hb = xt,
    $b = Yt,
    Bb = cn,
    Jb = io,
    Kb = a,
    Qb = zb,
    Zb = mn,
    t_ = Yb,
    e_ = Gb,
    r_ = ct,
    n_ = Ub,
    i_ = [],
    o_ = Vb(i_.sort),
    a_ = Vb(i_.push),
    u_ = Kb(function () {
      i_.sort(void 0);
    }),
    s_ = Kb(function () {
      i_.sort(null);
    }),
    c_ = Zb("sort"),
    f_ = !Kb(function () {
      if (r_) return r_ < 70;
      if (!(t_ && t_ > 3)) {
        if (e_) return !0;
        if (n_) return n_ < 603;
        var t,
          e,
          r,
          n,
          i = "";
        for (t = 65; t < 76; t++) {
          switch (e = String.fromCharCode(t), t) {
            case 66:
            case 69:
            case 70:
            case 72:
              r = 3;
              break;
            case 68:
            case 71:
              r = 4;
              break;
            default:
              r = 2;
          }
          for (n = 0; n < 47; n++) {
            i_.push({
              k: e + n,
              v: r
            });
          }
        }
        for (i_.sort(function (t, e) {
          return e.v - t.v;
        }), n = 0; n < i_.length; n++) {
          e = i_[n].k.charAt(0), i.charAt(i.length - 1) !== e && (i += e);
        }
        return "DGBEFHACIJK" !== i;
      }
    });
  Wb({
    target: "Array",
    proto: !0,
    forced: u_ || !s_ || !c_ || !f_
  }, {
    sort: function sort(t) {
      void 0 !== t && Hb(t);
      var e = $b(this);
      if (f_) return void 0 === t ? o_(e) : o_(e, t);
      var r,
        n,
        i = [],
        o = Bb(e);
      for (n = 0; n < o; n++) {
        n in e && a_(i, e[n]);
      }
      for (Qb(i, function (t) {
        return function (e, r) {
          return void 0 === r ? -1 : void 0 === e ? 1 : void 0 !== t ? +t(e, r) || 0 : Jb(e) > Jb(r) ? 1 : -1;
        };
      }(t)), r = i.length, n = 0; n < r;) {
        e[n] = i[n++];
      }
      for (; n < o;) {
        delete e[n++];
      }
      return e;
    }
  });
  var l_,
    h_ = Jr("Array").sort,
    p_ = et,
    v_ = h_,
    d_ = Array.prototype,
    y_ = function y_(t) {
      var e = t.sort;
      return t === d_ || p_(d_, t) && e === d_.sort ? v_ : e;
    },
    g_ = Jr("Array").values,
    m_ = zn,
    b_ = Ut,
    __ = et,
    w_ = g_,
    O_ = Array.prototype,
    E_ = {
      DOMTokenList: !0,
      NodeList: !0
    },
    T_ = function T_(t) {
      var e = t.values;
      return t === O_ || __(O_, t) && e === O_.values || b_(E_, m_(t)) ? w_ : e;
    },
    x_ = mh,
    k_ = Jr("Array").entries,
    S_ = zn,
    A_ = Ut,
    j_ = et,
    P_ = k_,
    I_ = Array.prototype,
    D_ = {
      DOMTokenList: !0,
      NodeList: !0
    },
    L_ = function L_(t) {
      var e = t.entries;
      return t === I_ || j_(I_, t) && e === I_.entries || A_(D_, S_(t)) ? P_ : e;
    },
    C_ = new Uint8Array(16);
  function R_() {
    if (!l_ && !(l_ = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return l_(C_);
  }
  var M_ = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
  function F_(t) {
    return "string" == typeof t && M_.test(t);
  }
  for (var N_ = [], z_ = 0; z_ < 256; ++z_) {
    N_.push((z_ + 256).toString(16).substr(1));
  }
  function q_(t, e, r) {
    var n = (t = t || {}).random || (t.rng || R_)();
    if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, e) {
      r = r || 0;
      for (var i = 0; i < 16; ++i) {
        e[r + i] = n[i];
      }
      return e;
    }
    return function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
        r = (N_[t[e + 0]] + N_[t[e + 1]] + N_[t[e + 2]] + N_[t[e + 3]] + "-" + N_[t[e + 4]] + N_[t[e + 5]] + "-" + N_[t[e + 6]] + N_[t[e + 7]] + "-" + N_[t[e + 8]] + N_[t[e + 9]] + "-" + N_[t[e + 10]] + N_[t[e + 11]] + N_[t[e + 12]] + N_[t[e + 13]] + N_[t[e + 14]] + N_[t[e + 15]]).toLowerCase();
      if (!F_(r)) throw TypeError("Stringified UUID is invalid");
      return r;
    }(n);
  }
  function Y_(t) {
    return "string" == typeof t || "number" == typeof t;
  }
  var G_ = function () {
      function t(r) {
        e(this, t), Cr(this, "delay", void 0), Cr(this, "max", void 0), Cr(this, "_queue", []), Cr(this, "_timeout", null), Cr(this, "_extended", null), this.delay = null, this.max = 1 / 0, this.setOptions(r);
      }
      return Lr(t, [{
        key: "setOptions",
        value: function value(t) {
          t && void 0 !== t.delay && (this.delay = t.delay), t && void 0 !== t.max && (this.max = t.max), this._flushIfNeeded();
        }
      }, {
        key: "destroy",
        value: function value() {
          if (this.flush(), this._extended) {
            for (var t = this._extended.object, e = this._extended.methods, r = 0; r < e.length; r++) {
              var n = e[r];
              n.original ? t[n.name] = n.original : delete t[n.name];
            }
            this._extended = null;
          }
        }
      }, {
        key: "replace",
        value: function value(t, e) {
          var r = this,
            n = t[e];
          if (!n) throw new Error("Method " + e + " undefined");
          t[e] = function () {
            for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) {
              e[i] = arguments[i];
            }
            r.queue({
              args: e,
              fn: n,
              context: this
            });
          };
        }
      }, {
        key: "queue",
        value: function value(t) {
          "function" == typeof t ? this._queue.push({
            fn: t
          }) : this._queue.push(t), this._flushIfNeeded();
        }
      }, {
        key: "_flushIfNeeded",
        value: function value() {
          var t = this;
          this._queue.length > this.max && this.flush(), null != this._timeout && (clearTimeout(this._timeout), this._timeout = null), this.queue.length > 0 && "number" == typeof this.delay && (this._timeout = bd(function () {
            t.flush();
          }, this.delay));
        }
      }, {
        key: "flush",
        value: function value() {
          var t, e;
          Hh(t = wp(e = this._queue).call(e, 0)).call(t, function (t) {
            t.fn.apply(t.context || t.fn, t.args || []);
          });
        }
      }], [{
        key: "extend",
        value: function value(e, r) {
          var n = new t(r);
          if (void 0 !== e.flush) throw new Error("Target object already has a property flush");
          e.flush = function () {
            n.flush();
          };
          var i = [{
            name: "flush",
            original: void 0
          }];
          if (r && r.replace) for (var o = 0; o < r.replace.length; o++) {
            var a = r.replace[o];
            i.push({
              name: a,
              original: e[a]
            }), n.replace(e, a);
          }
          return n._extended = {
            object: e,
            methods: i
          }, n;
        }
      }]), t;
    }(),
    X_ = function () {
      function t() {
        e(this, t), Cr(this, "_subscribers", {
          "*": [],
          add: [],
          remove: [],
          update: []
        }), Cr(this, "subscribe", t.prototype.on), Cr(this, "unsubscribe", t.prototype.off);
      }
      return Lr(t, [{
        key: "_trigger",
        value: function value(t, e, r) {
          var n, i;
          if ("*" === t) throw new Error("Cannot trigger event *");
          Hh(n = Sh(i = []).call(i, wh(this._subscribers[t]), wh(this._subscribers["*"]))).call(n, function (n) {
            n(t, e, null != r ? r : null);
          });
        }
      }, {
        key: "on",
        value: function value(t, e) {
          "function" == typeof e && this._subscribers[t].push(e);
        }
      }, {
        key: "off",
        value: function value(t, e) {
          var r;
          this._subscribers[t] = ji(r = this._subscribers[t]).call(r, function (t) {
            return t !== e;
          });
        }
      }]), t;
    }();
  tb("Set", function (t) {
    return function () {
      return t(this, arguments.length ? arguments[0] : void 0);
    };
  }, mb);
  var U_,
    W_ = B.Set,
    V_ = ws;
  function H_(t, e) {
    var r = void 0 !== Oh && ic(t) || t["@@iterator"];
    if (!r) {
      if (Ph(t) || (r = function (t, e) {
        var r;
        if (!t) return;
        if ("string" == typeof t) return $_(t, e);
        var n = Ah(r = Object.prototype.toString.call(t)).call(r, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return qs(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $_(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        r && (t = r);
        var _n3 = 0,
          i = function i() {};
        return {
          s: i,
          n: function n() {
            return _n3 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n3++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: i
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      a = !0,
      u = !1;
    return {
      s: function s() {
        r = r.call(t);
      },
      n: function n() {
        var t = r.next();
        return a = t.done, t;
      },
      e: function e(t) {
        u = !0, o = t;
      },
      f: function f() {
        try {
          a || null == r.return || r.return();
        } finally {
          if (u) throw o;
        }
      }
    };
  }
  function $_(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }
    return n;
  }
  U_ = x_;
  var B_ = function () {
    function t(r) {
      e(this, t), Cr(this, "_pairs", void 0), this._pairs = r;
    }
    return Lr(t, [{
      key: U_,
      value: Kg.mark(function t() {
        var e, r, n, i, o;
        return Kg.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e = H_(this._pairs), t.prev = 1, e.s();
              case 3:
                if ((r = e.n()).done) {
                  t.next = 9;
                  break;
                }
                return n = gh(r.value, 2), i = n[0], o = n[1], t.next = 7, [i, o];
              case 7:
                t.next = 3;
                break;
              case 9:
                t.next = 14;
                break;
              case 11:
                t.prev = 11, t.t0 = t.catch(1), e.e(t.t0);
              case 14:
                return t.prev = 14, e.f(), t.finish(14);
              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "entries",
      value: Kg.mark(function t() {
        var e, r, n, i, o;
        return Kg.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e = H_(this._pairs), t.prev = 1, e.s();
              case 3:
                if ((r = e.n()).done) {
                  t.next = 9;
                  break;
                }
                return n = gh(r.value, 2), i = n[0], o = n[1], t.next = 7, [i, o];
              case 7:
                t.next = 3;
                break;
              case 9:
                t.next = 14;
                break;
              case 11:
                t.prev = 11, t.t0 = t.catch(1), e.e(t.t0);
              case 14:
                return t.prev = 14, e.f(), t.finish(14);
              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "keys",
      value: Kg.mark(function t() {
        var e, r, n, i;
        return Kg.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e = H_(this._pairs), t.prev = 1, e.s();
              case 3:
                if ((r = e.n()).done) {
                  t.next = 9;
                  break;
                }
                return n = gh(r.value, 1), i = n[0], t.next = 7, i;
              case 7:
                t.next = 3;
                break;
              case 9:
                t.next = 14;
                break;
              case 11:
                t.prev = 11, t.t0 = t.catch(1), e.e(t.t0);
              case 14:
                return t.prev = 14, e.f(), t.finish(14);
              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "values",
      value: Kg.mark(function t() {
        var e, r, n, i;
        return Kg.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                e = H_(this._pairs), t.prev = 1, e.s();
              case 3:
                if ((r = e.n()).done) {
                  t.next = 9;
                  break;
                }
                return n = gh(r.value, 2), i = n[1], t.next = 7, i;
              case 7:
                t.next = 3;
                break;
              case 9:
                t.next = 14;
                break;
              case 11:
                t.prev = 11, t.t0 = t.catch(1), e.e(t.t0);
              case 14:
                return t.prev = 14, e.f(), t.finish(14);
              case 17:
              case "end":
                return t.stop();
            }
          }
        }, t, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "toIdArray",
      value: function value() {
        var t;
        return Ri(t = wh(this._pairs)).call(t, function (t) {
          return t[0];
        });
      }
    }, {
      key: "toItemArray",
      value: function value() {
        var t;
        return Ri(t = wh(this._pairs)).call(t, function (t) {
          return t[1];
        });
      }
    }, {
      key: "toEntryArray",
      value: function value() {
        return wh(this._pairs);
      }
    }, {
      key: "toObjectMap",
      value: function value() {
        var t,
          e = Yv(null),
          r = H_(this._pairs);
        try {
          for (r.s(); !(t = r.n()).done;) {
            var n = gh(t.value, 2),
              i = n[0],
              o = n[1];
            e[i] = o;
          }
        } catch (t) {
          r.e(t);
        } finally {
          r.f();
        }
        return e;
      }
    }, {
      key: "toMap",
      value: function value() {
        return new bb(this._pairs);
      }
    }, {
      key: "toIdSet",
      value: function value() {
        return new W_(this.toIdArray());
      }
    }, {
      key: "toItemSet",
      value: function value() {
        return new W_(this.toItemArray());
      }
    }, {
      key: "cache",
      value: function value() {
        return new t(wh(this._pairs));
      }
    }, {
      key: "distinct",
      value: function value(t) {
        var e,
          r = new W_(),
          n = H_(this._pairs);
        try {
          for (n.s(); !(e = n.n()).done;) {
            var i = gh(e.value, 2),
              o = i[0],
              a = i[1];
            r.add(t(a, o));
          }
        } catch (t) {
          n.e(t);
        } finally {
          n.f();
        }
        return r;
      }
    }, {
      key: "filter",
      value: function value(e) {
        var r = this._pairs;
        return new t(Cr({}, x_, Kg.mark(function t() {
          var n, i, o, a, u;
          return Kg.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  n = H_(r), t.prev = 1, n.s();
                case 3:
                  if ((i = n.n()).done) {
                    t.next = 10;
                    break;
                  }
                  if (o = gh(i.value, 2), a = o[0], u = o[1], !e(u, a)) {
                    t.next = 8;
                    break;
                  }
                  return t.next = 8, [a, u];
                case 8:
                  t.next = 3;
                  break;
                case 10:
                  t.next = 15;
                  break;
                case 12:
                  t.prev = 12, t.t0 = t.catch(1), n.e(t.t0);
                case 15:
                  return t.prev = 15, n.f(), t.finish(15);
                case 18:
                case "end":
                  return t.stop();
              }
            }
          }, t, null, [[1, 12, 15, 18]]);
        })));
      }
    }, {
      key: "forEach",
      value: function value(t) {
        var e,
          r = H_(this._pairs);
        try {
          for (r.s(); !(e = r.n()).done;) {
            var n = gh(e.value, 2),
              i = n[0];
            t(n[1], i);
          }
        } catch (t) {
          r.e(t);
        } finally {
          r.f();
        }
      }
    }, {
      key: "map",
      value: function value(e) {
        var r = this._pairs;
        return new t(Cr({}, x_, Kg.mark(function t() {
          var n, i, o, a, u;
          return Kg.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  n = H_(r), t.prev = 1, n.s();
                case 3:
                  if ((i = n.n()).done) {
                    t.next = 9;
                    break;
                  }
                  return o = gh(i.value, 2), a = o[0], u = o[1], t.next = 7, [a, e(u, a)];
                case 7:
                  t.next = 3;
                  break;
                case 9:
                  t.next = 14;
                  break;
                case 11:
                  t.prev = 11, t.t0 = t.catch(1), n.e(t.t0);
                case 14:
                  return t.prev = 14, n.f(), t.finish(14);
                case 17:
                case "end":
                  return t.stop();
              }
            }
          }, t, null, [[1, 11, 14, 17]]);
        })));
      }
    }, {
      key: "max",
      value: function value(t) {
        var e = V_(this._pairs),
          r = e.next();
        if (r.done) return null;
        for (var n = r.value[1], i = t(r.value[1], r.value[0]); !(r = e.next()).done;) {
          var o = gh(r.value, 2),
            a = o[0],
            u = o[1],
            s = t(u, a);
          s > i && (i = s, n = u);
        }
        return n;
      }
    }, {
      key: "min",
      value: function value(t) {
        var e = V_(this._pairs),
          r = e.next();
        if (r.done) return null;
        for (var n = r.value[1], i = t(r.value[1], r.value[0]); !(r = e.next()).done;) {
          var o = gh(r.value, 2),
            a = o[0],
            u = o[1],
            s = t(u, a);
          s < i && (i = s, n = u);
        }
        return n;
      }
    }, {
      key: "reduce",
      value: function value(t, e) {
        var r,
          n = H_(this._pairs);
        try {
          for (n.s(); !(r = n.n()).done;) {
            var i = gh(r.value, 2),
              o = i[0];
            e = t(e, i[1], o);
          }
        } catch (t) {
          n.e(t);
        } finally {
          n.f();
        }
        return e;
      }
    }, {
      key: "sort",
      value: function value(e) {
        var r = this;
        return new t(Cr({}, x_, function () {
          var t;
          return V_(y_(t = wh(r._pairs)).call(t, function (t, r) {
            var n = gh(t, 2),
              i = n[0],
              o = n[1],
              a = gh(r, 2),
              u = a[0],
              s = a[1];
            return e(o, s, i, u);
          }));
        }));
      }
    }]), t;
  }();
  function J_(t, e) {
    var r = Lh(t);
    if ($f) {
      var n = $f(t);
      e && (n = ji(n).call(n, function (e) {
        return il(t, e).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function K_(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r,
        n,
        i = null != arguments[e] ? arguments[e] : {};
      e % 2 ? Hh(r = J_(Object(i), !0)).call(r, function (e) {
        Cr(t, e, i[e]);
      }) : dl ? Ol(t, dl(i)) : Hh(n = J_(Object(i))).call(n, function (e) {
        El(t, e, il(i, e));
      });
    }
    return t;
  }
  function Q_(t, e) {
    var r = void 0 !== Oh && ic(t) || t["@@iterator"];
    if (!r) {
      if (Ph(t) || (r = function (t, e) {
        var r;
        if (!t) return;
        if ("string" == typeof t) return Z_(t, e);
        var n = Ah(r = Object.prototype.toString.call(t)).call(r, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return qs(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Z_(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        r && (t = r);
        var _n4 = 0,
          i = function i() {};
        return {
          s: i,
          n: function n() {
            return _n4 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n4++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: i
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      a = !0,
      u = !1;
    return {
      s: function s() {
        r = r.call(t);
      },
      n: function n() {
        var t = r.next();
        return a = t.done, t;
      },
      e: function e(t) {
        u = !0, o = t;
      },
      f: function f() {
        try {
          a || null == r.return || r.return();
        } finally {
          if (u) throw o;
        }
      }
    };
  }
  function Z_(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }
    return n;
  }
  function tw(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Yg) return !1;
      if (Yg.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Yg(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var r,
        n = Bg(t);
      if (e) {
        var i = Bg(this).constructor;
        r = Yg(n, arguments, i);
      } else r = n.apply(this, arguments);
      return Hg(this, r);
    };
  }
  var ew = function (t) {
    Vg(n, t);
    var r = tw(n);
    function n(t, i) {
      var o;
      return e(this, n), Cr(Gg(o = r.call(this)), "flush", void 0), Cr(Gg(o), "length", void 0), Cr(Gg(o), "_options", void 0), Cr(Gg(o), "_data", void 0), Cr(Gg(o), "_idProp", void 0), Cr(Gg(o), "_queue", null), t && !Ph(t) && (i = t, t = []), o._options = i || {}, o._data = new bb(), o.length = 0, o._idProp = o._options.fieldId || "id", t && t.length && o.add(t), o.setOptions(i), o;
    }
    return Lr(n, [{
      key: "idProp",
      get: function get() {
        return this._idProp;
      }
    }, {
      key: "setOptions",
      value: function value(t) {
        t && void 0 !== t.queue && (!1 === t.queue ? this._queue && (this._queue.destroy(), this._queue = null) : (this._queue || (this._queue = G_.extend(this, {
          replace: ["add", "update", "remove"]
        })), t.queue && "object" === _h(t.queue) && this._queue.setOptions(t.queue)));
      }
    }, {
      key: "add",
      value: function value(t, e) {
        var r,
          n = this,
          i = [];
        if (Ph(t)) {
          var o = Ri(t).call(t, function (t) {
            return t[n._idProp];
          });
          if (xb(o).call(o, function (t) {
            return n._data.has(t);
          })) throw new Error("A duplicate id was found in the parameter array.");
          for (var a = 0, u = t.length; a < u; a++) {
            r = this._addItem(t[a]), i.push(r);
          }
        } else {
          if (!t || "object" !== _h(t)) throw new Error("Unknown dataType");
          r = this._addItem(t), i.push(r);
        }
        return i.length && this._trigger("add", {
          items: i
        }, e), i;
      }
    }, {
      key: "update",
      value: function value(t, e) {
        var r = this,
          n = [],
          i = [],
          o = [],
          a = [],
          u = this._idProp,
          s = function s(t) {
            var e = t[u];
            if (null != e && r._data.has(e)) {
              var s = t,
                c = Mp({}, r._data.get(e)),
                f = r._updateItem(s);
              i.push(f), a.push(s), o.push(c);
            } else {
              var l = r._addItem(t);
              n.push(l);
            }
          };
        if (Ph(t)) for (var c = 0, f = t.length; c < f; c++) {
          t[c] && "object" === _h(t[c]) ? s(t[c]) : console.warn("Ignoring input item, which is not an object at index " + c);
        } else {
          if (!t || "object" !== _h(t)) throw new Error("Unknown dataType");
          s(t);
        }
        if (n.length && this._trigger("add", {
          items: n
        }, e), i.length) {
          var l = {
            items: i,
            oldData: o,
            data: a
          };
          this._trigger("update", l, e);
        }
        return Sh(n).call(n, i);
      }
    }, {
      key: "updateOnly",
      value: function value(t, e) {
        var r,
          n = this;
        Ph(t) || (t = [t]);
        var i = Ri(r = Ri(t).call(t, function (t) {
          var e = n._data.get(t[n._idProp]);
          if (null == e) throw new Error("Updating non-existent items is not allowed.");
          return {
            oldData: e,
            update: t
          };
        })).call(r, function (t) {
          var e = t.oldData,
            r = t.update,
            i = e[n._idProp],
            o = function (t) {
              for (var e, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
                n[i - 1] = arguments[i];
              }
              return mg.apply(void 0, Sh(e = [{}, t]).call(e, n));
            }(e, r);
          return n._data.set(i, o), {
            id: i,
            oldData: e,
            updatedData: o
          };
        });
        if (i.length) {
          var o = {
            items: Ri(i).call(i, function (t) {
              return t.id;
            }),
            oldData: Ri(i).call(i, function (t) {
              return t.oldData;
            }),
            data: Ri(i).call(i, function (t) {
              return t.updatedData;
            })
          };
          return this._trigger("update", o, e), o.items;
        }
        return [];
      }
    }, {
      key: "get",
      value: function value(t, e) {
        var r = void 0,
          n = void 0,
          i = void 0;
        Y_(t) ? (r = t, i = e) : Ph(t) ? (n = t, i = e) : i = t;
        var o,
          a = i && "Object" === i.returnType ? "Object" : "Array",
          u = i && ji(i),
          s = [],
          c = void 0,
          f = void 0,
          l = void 0;
        if (null != r) (c = this._data.get(r)) && u && !u(c) && (c = void 0);else if (null != n) for (var h = 0, p = n.length; h < p; h++) {
          null == (c = this._data.get(n[h])) || u && !u(c) || s.push(c);
        } else for (var v, d = 0, y = (f = wh(Lb(v = this._data).call(v))).length; d < y; d++) {
          l = f[d], null == (c = this._data.get(l)) || u && !u(c) || s.push(c);
        }
        if (i && i.order && null == r && this._sort(s, i.order), i && i.fields) {
          var g = i.fields;
          if (null != r && null != c) c = this._filterFields(c, g);else for (var m = 0, b = s.length; m < b; m++) {
            s[m] = this._filterFields(s[m], g);
          }
        }
        if ("Object" == a) {
          for (var _ = {}, w = 0, O = s.length; w < O; w++) {
            var E = s[w];
            _[E[this._idProp]] = E;
          }
          return _;
        }
        return null != r ? null !== (o = c) && void 0 !== o ? o : null : s;
      }
    }, {
      key: "getIds",
      value: function value(t) {
        var e = this._data,
          r = t && ji(t),
          n = t && t.order,
          i = wh(Lb(e).call(e)),
          o = [];
        if (r) {
          if (n) {
            for (var a = [], u = 0, s = i.length; u < s; u++) {
              var c = i[u],
                f = this._data.get(c);
              null != f && r(f) && a.push(f);
            }
            this._sort(a, n);
            for (var l = 0, h = a.length; l < h; l++) {
              o.push(a[l][this._idProp]);
            }
          } else for (var p = 0, v = i.length; p < v; p++) {
            var d = i[p],
              y = this._data.get(d);
            null != y && r(y) && o.push(y[this._idProp]);
          }
        } else if (n) {
          for (var g = [], m = 0, b = i.length; m < b; m++) {
            var _ = i[m];
            g.push(e.get(_));
          }
          this._sort(g, n);
          for (var w = 0, O = g.length; w < O; w++) {
            o.push(g[w][this._idProp]);
          }
        } else for (var E = 0, T = i.length; E < T; E++) {
          var x = i[E],
            k = e.get(x);
          null != k && o.push(k[this._idProp]);
        }
        return o;
      }
    }, {
      key: "getDataSet",
      value: function value() {
        return this;
      }
    }, {
      key: "forEach",
      value: function value(t, e) {
        var r = e && ji(e),
          n = this._data,
          i = wh(Lb(n).call(n));
        if (e && e.order) for (var o = this.get(e), a = 0, u = o.length; a < u; a++) {
          var s = o[a];
          t(s, s[this._idProp]);
        } else for (var c = 0, f = i.length; c < f; c++) {
          var l = i[c],
            h = this._data.get(l);
          null == h || r && !r(h) || t(h, l);
        }
      }
    }, {
      key: "map",
      value: function value(t, e) {
        for (var r = e && ji(e), n = [], i = this._data, o = wh(Lb(i).call(i)), a = 0, u = o.length; a < u; a++) {
          var s = o[a],
            c = this._data.get(s);
          null == c || r && !r(c) || n.push(t(c, s));
        }
        return e && e.order && this._sort(n, e.order), n;
      }
    }, {
      key: "_filterFields",
      value: function value(t, e) {
        var r;
        return t ? Sn(r = Ph(e) ? e : Lh(e)).call(r, function (e, r) {
          return e[r] = t[r], e;
        }, {}) : t;
      }
    }, {
      key: "_sort",
      value: function value(t, e) {
        if ("string" == typeof e) {
          var r = e;
          y_(t).call(t, function (t, e) {
            var n = t[r],
              i = e[r];
            return n > i ? 1 : n < i ? -1 : 0;
          });
        } else {
          if ("function" != typeof e) throw new TypeError("Order must be a function or a string");
          y_(t).call(t, e);
        }
      }
    }, {
      key: "remove",
      value: function value(t, e) {
        for (var r = [], n = [], i = Ph(t) ? t : [t], o = 0, a = i.length; o < a; o++) {
          var u = this._remove(i[o]);
          if (u) {
            var s = u[this._idProp];
            null != s && (r.push(s), n.push(u));
          }
        }
        return r.length && this._trigger("remove", {
          items: r,
          oldData: n
        }, e), r;
      }
    }, {
      key: "_remove",
      value: function value(t) {
        var e;
        if (Y_(t) ? e = t : t && "object" === _h(t) && (e = t[this._idProp]), null != e && this._data.has(e)) {
          var r = this._data.get(e) || null;
          return this._data.delete(e), --this.length, r;
        }
        return null;
      }
    }, {
      key: "clear",
      value: function value(t) {
        for (var e, r = wh(Lb(e = this._data).call(e)), n = [], i = 0, o = r.length; i < o; i++) {
          n.push(this._data.get(r[i]));
        }
        return this._data.clear(), this.length = 0, this._trigger("remove", {
          items: r,
          oldData: n
        }, t), r;
      }
    }, {
      key: "max",
      value: function value(t) {
        var e,
          r,
          n = null,
          i = null,
          o = Q_(T_(e = this._data).call(e));
        try {
          for (o.s(); !(r = o.n()).done;) {
            var a = r.value,
              u = a[t];
            "number" == typeof u && (null == i || u > i) && (n = a, i = u);
          }
        } catch (t) {
          o.e(t);
        } finally {
          o.f();
        }
        return n || null;
      }
    }, {
      key: "min",
      value: function value(t) {
        var e,
          r,
          n = null,
          i = null,
          o = Q_(T_(e = this._data).call(e));
        try {
          for (o.s(); !(r = o.n()).done;) {
            var a = r.value,
              u = a[t];
            "number" == typeof u && (null == i || u < i) && (n = a, i = u);
          }
        } catch (t) {
          o.e(t);
        } finally {
          o.f();
        }
        return n || null;
      }
    }, {
      key: "distinct",
      value: function value(t) {
        for (var e = this._data, r = wh(Lb(e).call(e)), n = [], i = 0, o = 0, a = r.length; o < a; o++) {
          for (var u = r[o], s = e.get(u)[t], c = !1, f = 0; f < i; f++) {
            if (n[f] == s) {
              c = !0;
              break;
            }
          }
          c || void 0 === s || (n[i] = s, i++);
        }
        return n;
      }
    }, {
      key: "_addItem",
      value: function value(t) {
        var e = function (t, e) {
            return null == t[e] && (t[e] = q_()), t;
          }(t, this._idProp),
          r = e[this._idProp];
        if (this._data.has(r)) throw new Error("Cannot add item: item with id " + r + " already exists");
        return this._data.set(r, e), ++this.length, r;
      }
    }, {
      key: "_updateItem",
      value: function value(t) {
        var e = t[this._idProp];
        if (null == e) throw new Error("Cannot update item: item has no id (item: " + sd(t) + ")");
        var r = this._data.get(e);
        if (!r) throw new Error("Cannot update item: no item with id " + e + " found");
        return this._data.set(e, K_(K_({}, r), t)), e;
      }
    }, {
      key: "stream",
      value: function value(t) {
        if (t) {
          var e = this._data;
          return new B_(Cr({}, x_, Kg.mark(function r() {
            var n, i, o, a;
            return Kg.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    n = Q_(t), r.prev = 1, n.s();
                  case 3:
                    if ((i = n.n()).done) {
                      r.next = 11;
                      break;
                    }
                    if (o = i.value, null == (a = e.get(o))) {
                      r.next = 9;
                      break;
                    }
                    return r.next = 9, [o, a];
                  case 9:
                    r.next = 3;
                    break;
                  case 11:
                    r.next = 16;
                    break;
                  case 13:
                    r.prev = 13, r.t0 = r.catch(1), n.e(r.t0);
                  case 16:
                    return r.prev = 16, n.f(), r.finish(16);
                  case 19:
                  case "end":
                    return r.stop();
                }
              }
            }, r, null, [[1, 13, 16, 19]]);
          })));
        }
        var r;
        return new B_(Cr({}, x_, en(r = L_(this._data)).call(r, this._data)));
      }
    }]), n;
  }(X_);
  function rw(t, e) {
    var r = void 0 !== Oh && ic(t) || t["@@iterator"];
    if (!r) {
      if (Ph(t) || (r = function (t, e) {
        var r;
        if (!t) return;
        if ("string" == typeof t) return nw(t, e);
        var n = Ah(r = Object.prototype.toString.call(t)).call(r, 8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return qs(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nw(t, e);
      }(t)) || e && t && "number" == typeof t.length) {
        r && (t = r);
        var _n5 = 0,
          i = function i() {};
        return {
          s: i,
          n: function n() {
            return _n5 >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[_n5++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: i
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      a = !0,
      u = !1;
    return {
      s: function s() {
        r = r.call(t);
      },
      n: function n() {
        var t = r.next();
        return a = t.done, t;
      },
      e: function e(t) {
        u = !0, o = t;
      },
      f: function f() {
        try {
          a || null == r.return || r.return();
        } finally {
          if (u) throw o;
        }
      }
    };
  }
  function nw(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) {
      n[r] = t[r];
    }
    return n;
  }
  function iw(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Yg) return !1;
      if (Yg.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Yg(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var r,
        n = Bg(t);
      if (e) {
        var i = Bg(this).constructor;
        r = Yg(n, arguments, i);
      } else r = n.apply(this, arguments);
      return Hg(this, r);
    };
  }
  var ow = function (t) {
    Vg(n, t);
    var r = iw(n);
    function n(t, i) {
      var o, a;
      return e(this, n), Cr(Gg(a = r.call(this)), "length", 0), Cr(Gg(a), "_listener", void 0), Cr(Gg(a), "_data", void 0), Cr(Gg(a), "_ids", new W_()), Cr(Gg(a), "_options", void 0), a._options = i || {}, a._listener = en(o = a._onEvent).call(o, Gg(a)), a.setData(t), a;
    }
    return Lr(n, [{
      key: "idProp",
      get: function get() {
        return this.getDataSet().idProp;
      }
    }, {
      key: "setData",
      value: function value(t) {
        if (this._data) {
          this._data.off && this._data.off("*", this._listener);
          var e = this._data.getIds({
              filter: ji(this._options)
            }),
            r = this._data.get(e);
          this._ids.clear(), this.length = 0, this._trigger("remove", {
            items: e,
            oldData: r
          });
        }
        if (null != t) {
          this._data = t;
          for (var n = this._data.getIds({
              filter: ji(this._options)
            }), i = 0, o = n.length; i < o; i++) {
            var a = n[i];
            this._ids.add(a);
          }
          this.length = n.length, this._trigger("add", {
            items: n
          });
        } else this._data = new ew();
        this._data.on && this._data.on("*", this._listener);
      }
    }, {
      key: "refresh",
      value: function value() {
        for (var t = this._data.getIds({
            filter: ji(this._options)
          }), e = wh(this._ids), r = {}, n = [], i = [], o = [], a = 0, u = t.length; a < u; a++) {
          var s = t[a];
          r[s] = !0, this._ids.has(s) || (n.push(s), this._ids.add(s));
        }
        for (var c = 0, f = e.length; c < f; c++) {
          var l = e[c],
            h = this._data.get(l);
          null == h ? console.error("If you see this, report it please.") : r[l] || (i.push(l), o.push(h), this._ids.delete(l));
        }
        this.length += n.length - i.length, n.length && this._trigger("add", {
          items: n
        }), i.length && this._trigger("remove", {
          items: i,
          oldData: o
        });
      }
    }, {
      key: "get",
      value: function value(t, e) {
        if (null == this._data) return null;
        var r,
          n = null;
        Y_(t) || Ph(t) ? (n = t, r = e) : r = t;
        var i = Mp({}, this._options, r),
          o = ji(this._options),
          a = r && ji(r);
        return o && a && (i.filter = function (t) {
          return o(t) && a(t);
        }), null == n ? this._data.get(i) : this._data.get(n, i);
      }
    }, {
      key: "getIds",
      value: function value(t) {
        if (this._data.length) {
          var e,
            r = ji(this._options),
            n = null != t ? ji(t) : null;
          return e = n ? r ? function (t) {
            return r(t) && n(t);
          } : n : r, this._data.getIds({
            filter: e,
            order: t && t.order
          });
        }
        return [];
      }
    }, {
      key: "forEach",
      value: function value(t, e) {
        if (this._data) {
          var r,
            n,
            i = ji(this._options),
            o = e && ji(e);
          n = o ? i ? function (t) {
            return i(t) && o(t);
          } : o : i, Hh(r = this._data).call(r, t, {
            filter: n,
            order: e && e.order
          });
        }
      }
    }, {
      key: "map",
      value: function value(t, e) {
        if (this._data) {
          var r,
            n,
            i = ji(this._options),
            o = e && ji(e);
          return n = o ? i ? function (t) {
            return i(t) && o(t);
          } : o : i, Ri(r = this._data).call(r, t, {
            filter: n,
            order: e && e.order
          });
        }
        return [];
      }
    }, {
      key: "getDataSet",
      value: function value() {
        return this._data.getDataSet();
      }
    }, {
      key: "stream",
      value: function value(t) {
        var e;
        return this._data.stream(t || Cr({}, x_, en(e = Lb(this._ids)).call(e, this._ids)));
      }
    }, {
      key: "dispose",
      value: function value() {
        var t;
        null !== (t = this._data) && void 0 !== t && t.off && this._data.off("*", this._listener);
        var e,
          r = "This data view has already been disposed of.",
          i = {
            get: function get() {
              throw new Error(r);
            },
            set: function set() {
              throw new Error(r);
            },
            configurable: !1
          },
          o = rw(jh(n.prototype));
        try {
          for (o.s(); !(e = o.n()).done;) {
            var a = e.value;
            El(this, a, i);
          }
        } catch (t) {
          o.e(t);
        } finally {
          o.f();
        }
      }
    }, {
      key: "_onEvent",
      value: function value(t, e, r) {
        if (e && e.items && this._data) {
          var n = e.items,
            i = [],
            o = [],
            a = [],
            u = [],
            s = [],
            c = [];
          switch (t) {
            case "add":
              for (var f = 0, l = n.length; f < l; f++) {
                var h = n[f];
                this.get(h) && (this._ids.add(h), i.push(h));
              }
              break;
            case "update":
              for (var p = 0, v = n.length; p < v; p++) {
                var d = n[p];
                this.get(d) ? this._ids.has(d) ? (o.push(d), s.push(e.data[p]), u.push(e.oldData[p])) : (this._ids.add(d), i.push(d)) : this._ids.has(d) && (this._ids.delete(d), a.push(d), c.push(e.oldData[p]));
              }
              break;
            case "remove":
              for (var y = 0, g = n.length; y < g; y++) {
                var m = n[y];
                this._ids.has(m) && (this._ids.delete(m), a.push(m), c.push(e.oldData[y]));
              }
          }
          this.length += i.length - a.length, i.length && this._trigger("add", {
            items: i
          }, r), o.length && this._trigger("update", {
            items: o,
            oldData: u,
            data: s
          }, r), a.length && this._trigger("remove", {
            items: a,
            oldData: c
          }, r);
        }
      }
    }]), n;
  }(X_);
  function aw(t, e) {
    return "object" === _h(e) && null !== e && t === e.idProp && "function" == typeof e.add && "function" == typeof e.clear && "function" == typeof e.distinct && "function" == typeof Hh(e) && "function" == typeof e.get && "function" == typeof e.getDataSet && "function" == typeof e.getIds && "number" == typeof e.length && "function" == typeof Ri(e) && "function" == typeof e.max && "function" == typeof e.min && "function" == typeof e.off && "function" == typeof e.on && "function" == typeof e.remove && "function" == typeof e.setOptions && "function" == typeof e.stream && "function" == typeof e.update && "function" == typeof e.updateOnly;
  }
  t.DELETE = gg, t.DataSet = ew, t.DataStream = B_, t.DataView = ow, t.Queue = G_, t.createNewDataPipeFrom = function (t) {
    return new eo(t);
  }, t.isDataSetLike = aw, t.isDataViewLike = function (t, e) {
    return "object" === _h(e) && null !== e && t === e.idProp && "function" == typeof Hh(e) && "function" == typeof e.get && "function" == typeof e.getDataSet && "function" == typeof e.getIds && "number" == typeof e.length && "function" == typeof Ri(e) && "function" == typeof e.off && "function" == typeof e.on && "function" == typeof e.stream && aw(t, e.getDataSet());
  }, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});